import { createI18n } from "vue-i18n";

const messages = {
  en: {
    /* General */
    GENERAL_titulo_bienvenida: "Welcome to ColvenNet",
    GENERAL_mensaje_bienvenida: "COLVEN S.A.",
    GENERAL_checkingCredentials: "Checking credentials",
    GENERAL_requiredField: "This field can't be empty",
    GENERAL_saveBtn: "Save",
    GENERAL_editBtn: "Edit",
    GENERAL_confirmBtn: "Confirm",
    GENERAL_deleteBtn: "Delete",
    GENERAL_cancelBtn: "Cancel",
    GENERAL_acceptBtn: "Accept",
    GENERAL_si: "Yes",
    GENERAL_no: "No",
    GENERAL_filtrar: "filter",
    GENERAL_filtrarProductos: "Search product by code or description",
    GENERAL_okBtn: "OK",
    GENERAL_exportBtn: "Export",
    GENERAL_importBtn: "Import",
    GENERAL_success: "Successful operation",
    GENERAL_no_data: "Data not found",
    GENERAL_opcional: "Optional",
    GENERAL_enviar: "Send",
    GENERAL_volver: "Back",
    GENERAL_asociar: "Associate",
    GENERAL_descargar: "Download",
    GENERAL_clean_filters: "Clean filters",
    GENERAL_OPCION_TODOS: "< All >",
    GENERAL_Busqueda_Simple: "Simple search",
    GENERAL_Busqueda: "Search",
    GENERAL_Busqueda_Avanzada: "Advanced search",
    GENERAL_nuevo: "New",
    GENERAL_desde: "From",
    GENERAL_hasta: "To",
    GENERAL_resultado: "Search results",
    GENERAL_fecha: "Date",
    GENERAL_subtotal: "Subtotal",
    GENERAL_descripcion: "Description",
    GENERAL_seleccione: "Select",
    GENERAL_atencion: "Attention",
    GENERAL_agregar_continuar: "Add and continue",
    GENERAL_desea_cancelar: "Do you want to cancel?",
    GENERAL_cancelar_mensaje:
      "The changes you implemented may not be able to be saved",
    GENERAL_salir: "Exit",
    GENERAL_infoColven: "Central Office and Industrial Plant in Argentina",
    GENERAL_filtros: "Filters",
    GENERAL_cargando: "Loading",
    GENERAL_cantidadPaginas: "Page [paginaActual] of [totalPagina]",
    GENERAL_buscando: "Searching",

    GENERAL_img_upload_btn: "Upload image",
    GENERAL_img_upload_btn_plural: "Upload images",
    GENERAL_img_upload_error:
      "An error occurred while trying to load one of the files",
    GENERAL_img_upload_limit: "The limit is 3 files, you selected ",
    GENERAL_img_remove_confirm: "Are you sure you want to remove ",

    GENERAL_missing_nro_serie: "Please enter a valid serial number.",
    GENERAL_missing_nro_serie_asoc:
      "Please enter a valid serial number of the selected item.",
    GENERAL_missing_fec_instalcion: "Installation date needs to be completed",
    GENERAL_missing_rz_soc: "The company name needs to be completed",
    GENERAL_missing_telefono: "The number phone needs to be completed.",
    GENERAL_missing_patente: "Patent needs to be completed.",
    GENERAL_missing_marca_modelo: "The brand and model needs to be completed.",
    GENERAL_missing_imagen_garantia: "It's necessary to attach the two images",

    /* Contacto */
    CONTACTO_contacto: "Contact",
    CONTACTO_enviar: "Send to",
    CONTACTO_mensaje: "Message",
    CONTACTO_missing_enviar:
      "Select the department which you want to send the message",
    CONTACTO_missing_mensaje: "Enter the message to send",
    CONTACTO_success: "The email was sent correctly",
    CONTACTO_error: "An error occurred while trying to send the email",
    CONTACTO_a_su_disposicion:
      "We are available for any questions or inconvenience:",

    /* Perfil */
    PERFIL_perfil: "Profile",
    PERFIL_empty_state: "No data to show",
    PERFIL_empresa: "Company",
    PERFIL_razon_social: "Company name",
    PERFIL_domicilio: "Address",
    PERFIL_localidad: "Locality",
    PERFIL_cp: "Zip code",
    PERFIL_pcia_estado: "State",
    PERFIL_pais: "Country",
    PERFIL_lineas: "Lines you sell",
    PERFIL_tel_mail: "Phone number / Email",
    PERFIL_area: "Area",
    PERFIL_tipo: "Type",
    PERFIL_usado_para: "Used for",
    PERFIL_direcciones: "Addresses",
    PERFIL_provincia: "Province",
    PERFIL_pcia_clave: "Key province",
    PERFIL_tel_direccion: "Phone numbers of this address",
    PERFIL_tel_asoc: "Associated phone numbers",
    PERFIL_nro_mail: "Number/Email",

    PERFIL_edicion: "Profile editing",
    PERFIL_instrucciones:
      "Indicate below the data of your company that suggests updating in our records:",
    PERFIL_editar: "Edit",
    PERFIL_mensaje: "Message",
    PERFIL_mensaje_placeholder: "Data you want to change",
    PERFIL_upload_img: "Upload business photo",
    PERFIL_missing_mensaje: "Enter the message to send",
    PERFIL_success: "The email was sent correctly",
    PERFIL_error: "An error occurred while trying to send the email",

    /* Login */
    LOGIN_loginTitle: "Welcome to ColvenNet",
    LOGIN_user: "Username",
    LOGIN_email: "Email",
    LOGIN_password: "Password",
    LOGIN_new_password: "New password",
    LOGIN_confirm_password: "Confirm password",
    LOGIN_password_mismatch: "Password do not match",

    LOGIN_loginBtn: "LOGIN",
    LOGIN_sendButton: "SEND",
    LOGIN_confirmBtn: "CONFIRM",
    LOGIN_saveBtn: "SAVE",
    LOGIN_invalidLogin: "The username or password are invalid",
    LOGIN_forgotPassword: "I forgot my password",
    LOGIN_resetPasswordMsg:
      "Please enter your username. You will receive an email with instructions on how to recover your password.",
    LOGIN_contact: "Contact",

    LOGIN_activeSesion: "Active session",
    LOGIN_forceCloseBtn: "Force session",
    LOGIN_activeSessionMsg:
      "An active session already exists for user [USERNAME]. Only one active session per user is allowed.",
    LOGIN_activeSesionClosed: "Successful operation, you can now login",
    LOGIN_activeSesionError: "Error forcing logout",

    LOGIN_expiredPassword: "Expired password. It is required to change the password.",

    /* 2FA */
    TWO_FACTOR_AUTHENTICATION_twoFactorAuthentication: "Two-factor authentication",
    TWO_FACTOR_AUTHENTICATION_scanQR: "Scan the QR code",
    TWO_FACTOR_AUTHENTICATION_enterCode: "Enter the code",
    TWO_FACTOR_AUTHENTICATION_verify: "VERIFY",
    TWO_FACTOR_AUTHENTICATION_6DigitsCode: "Enter 6-digit code",
    TWO_FACTOR_AUTHENTICATION_verifyError: "Invalid code",
    TWO_FACTOR_AUTHENTICATION_verifySuccess: "Successful verification",
    TWO_FACTOR_AUTHENTICATION_codeSaved: "Code saved successfully",
    TWO_FACTOR_AUTHENTICATION_title: "Enter Security Code",
    TWO_FACTOR_AUTHENTICATION_message: "Enter the 6-digit code in your authentication app.",
    TWO_FACTOR_AUTHENTICATION_explanation: "We use two-factor authentication to provide greater security for your account. To do this, you need to follow these steps:",
    TWO_FACTOR_AUTHENTICATION_item1: "1. Download the Google Authenticator app on your mobile device.",
    TWO_FACTOR_AUTHENTICATION_item2: "2. Scan the QR code shown below.",
    TWO_FACTOR_AUTHENTICATION_item3: "3. Enter the 6-digit code displayed in the Google Authenticator app.",
    TWO_FACTOR_AUTHENTICATION_item4: "4. If the code is verified, it will be saved and associated with your account.",
    TWO_FACTOR_AUTHENTICATION_requiredField: "This field must have 6 numbers",
    TWO_FACTOR_AUTHENTICATION_reasonToActivate: "To provide greater security to your account, you can activate two-factor authentication using the Authenticator application.",
    TWO_FACTOR_AUTHENTICATION_activateBtn: "ACTIVATE",
    TWO_FACTOR_AUTHENTICATION_deactivate2FA: "Deactivate two-factor authentication",
    TWO_FACTOR_AUTHENTICATION_disableSuccess: "Two-factor authentication has been successfully disabled",
    TWO_FACTOR_AUTHENTICATION_disableError: "Error disabling two-factor authentication",
    TWO_FACTOR_AUTHENTICATION_disableConfirm: "Do you want to disable two-factor authentication?",
    TWO_FACTOR_AUTHENTICATION_disableBtn: "DISABLE",
    TWO_FACTOR_AUTHENTICATION_disableTitle: "Disable two-factor authentication",

    /* Nuevo usuario */
    NEW_USER_userExists: "User alredy exists",
    NEW_USER_invalidUser: "Invalid user",
    NEW_USER_savePassordSuccess: "Password saved successfully",

    /* Cambio de contraseña */
    CHANGE_PASS_changePassword: "Change of password",
    CHANGE_PASS_currentPassword: "Current password",
    CHANGE_PASS_newPassword: "New password",
    CHANGE_PASS_repeatNewPassword: "Repeat current password",
    CHANGE_PASS_passwordNotEquals: "Passwords do not match",
    CHANGE_PASS_changePasswordSuccess: "Successful password change",
    CHANGE_PASS_invalidPassword: "Invalid password",
    CHANGE_PASS_errorOnChangePassword: "Error updating password",
    CHANGE_PASS_emptyPassword: "The new password cannot be empty",

    /* Recuperar contraseña */
    RETRIEVE_PASS_emailSent: "Email sent",

    /* Sesión expirada */
    EXPIRED_SESION_title: "Session expired",
    EXPIRED_SESION_msg:
      "The session has expired. Please enter your username and password again",

    /* Navbar */
    NAVBAR_inicio: "Home",
    NAVBAR_productos: "Warranties",
    NAVBAR_cuentas: "Current Account",
    NAVBAR_comunidad: "Community",
    NAVBAR_pedidos: "Orders",
    NAVBAR_reg_instalacion: "Installation records",
    NAVBAR_expire_warranty: "Warranties about to expire",
    NAVBAR_solicitudes: "Service requests",
    NAVBAR_remitos: "Association to remittances",
    NAVBAR_noticias: "News",
    NAVBAR_pagos: "Payments",
    NAVBAR_foro: "Forum",
    NAVBAR_archivos: "Archives",
    NAVBAR_contacto: "Contact",
    NAVBAR_gestionNoticias: "News management",
    NAVBAR_presupuestos: "Budgets",
    NAVBAR_pedidosSubagentes: "Subagents Orders",
    NAVBAR_pedidosDistribuidores: "Orders to Distributor",
    NAVBAR_pendientes: "Pending Documents",
    NAVBAR_resumenDeCuenta: "Account summary",
    NAVBAR_clientes: "Customers",

    /* Resumen de cuenta */
    RESUMENDECUENTA_cuenta: "Account",
    RESUMENDECUENTA_recibo: "Receipt",
    RESUMENDECUENTA_loading: "Getting summary",
    RESUMENDECUENTA_cuenta_sin_confirmar: "Unconfirmed",
    RESUMENDECUENTA_periodo_meses_1: "Last month",
    RESUMENDECUENTA_periodo_meses_2: "Last two months",
    RESUMENDECUENTA_periodo_meses_3: "Last three monts",
    RESUMENDECUENTA_periodo_ultimos_2anios: "Last two years",
    RESUMENDECUENTA_sin_confirmar: "Amount of unconfirmed documents",
    RESUMENDECUENTA_tabla_fecha: "Date",
    RESUMENDECUENTA_tabla_documento: "Documents",
    RESUMENDECUENTA_tabla_acciones: "Actions",
    RESUMENDECUENTA_tabla_descripcion: "Description",
    RESUMENDECUENTA_tabla_debe: "Debit",
    RESUMENDECUENTA_tabla_haber: "Credit",
    RESUMENDECUENTA_tabla_totales: "Totals",
    RESUMENDECUENTA_tabla_diferencia_haber_debe: "Difference Debit - Credit:",
    RESUMENDECUENTA_label_documento_seleccionado: "Document: ",
    RESUMENDECUENTA_tabla_cancelaciones_documento: "Document",
    RESUMENDECUENTA_tabla_cancelaciones_cuoata: "Installments",
    RESUMENDECUENTA_tabla_cancelaciones_vence: "Due Date",
    RESUMENDECUENTA_tabla_cancelaciones_debe: "Debit",
    RESUMENDECUENTA_tabla_cancelaciones_cancelado: "Canceled",
    RESUMENDECUENTA_verRecibo: 'Show receipt',
    RESUMENDECUENTA_descargarFactura: 'Download document',
    RESUMENDECUENTA_verCancelaciones: 'Show document cancellations',
    RESUMENDECUENTA_descargar_excel: "Export to Excel",
    RESUMENDECUENTA_exportar: "Export",
    RESUMENDECUENTA_fecha: 'Date',
    RESUMENDECUENTA_cliClave: 'Key',
    RESUMENDECUENTA_razonSocial: 'Business name',
    RESUMENDECUENTA_CodigoEmpresa: 'Company code',
    RESUMENDECUENTA_sucursal: 'Branch office',
    RESUMENDECUENTA_importeTotal: 'Total',
    RESUMENDECUENTA_tipoDocumento: 'Type',
    RESUMENDECUENTA_numero: 'Number',
    RESUMENDECUENTA_banco: 'Bank',
    RESUMENDECUENTA_importe: 'Ammount',
    RESUMENDECUENTA_concepto: 'Concept',
    RESUMENDECUENTA_saldo: 'Balance',
    RESUMENDECUENTA_montoSinImputar: 'Unimputed amount',
    RESUMENDECUENTA_errorObtencionCuentas: "The account types couldn't be retrieved",
    RESUMENDECUENTA_errorDescargaFactura: "The bill couldn't be downloaded",
    RESUMENDECUENTA_errorObtencionRecibo: "The receipt couldn't be retrieved",
    RESUMENDECUENTA_errorObtencionDocumentos: "The documents couldn't be retrieved",
    RESUMENDECUENTA_errorObtencionCancelaciones: "The document cancellations couldn't be retrieved",
    RESUMENDECUENTA_RealizarConsulta: 'Make an inquery',
    RESUMENDECUENTA_clientes: "Customers",
    RESUMENDECUENTA_clientes_placeholder: "Enter a customer name or lastname",
    RESUMENDECUENTA_cuentas: "Accounts",
    RESUMENDECUENTA_cuentas_placeholder: "Select a customer account",
    RESUMENDECUENTA_errorObtencionClientes: "The customer list couldn't be retrieved",

    PEDIDO_pedido: "Order",
    PEDIDO_instancia: "Instance",
    PEDIDO_ingresadoPor: "Entered by",
    PEDIDO_instancia_sin_confirmar: "Unconfirmed",
    PEDIDO_instancia_proceso: "In process",
    PEDIDO_instancia_historico: "Historical",
    PEDIDO_instancia_confirmado: "Confirmed",
    PEDIDO_numero: "Number",
    PEDIDO_numero_placeholder: "Enter the number",
    PEDIDO_periodo_meses_1: "Last month",
    PEDIDO_periodo_meses_2: "Last two months",
    PEDIDO_periodo_meses_3: "Last three monts",
    PEDIDO_periodo_ultimos_2anios: "Last two years",

    PEDIDO_inicializando_cabecera: "Initializing header",
    PEDIDO_numero_pedido: "Order number",
    PEDIDO_plazo_pago: "Payment deadline",
    PEDIDO_nota_comercial: "Commercial note",
    PEDIDO_nuevo_pedido: "New order",
    PEDIDO_importe_final: "Final amount",
    PEDIDO_sin_impuesto_ingresos_brutos: "Gross Income Tax is not included",
    PEDIDO_referencia_base_dolar:
      "(+) Dollar-based prices, at the time of invoicing it will be updated with the price of the day before the invoice date of the Banco Nación seller type",
    PEDIDO_subtotal: "Subtotal",
    PEDIDO_iva: "VAT",
    PEDIDO_despachado: "Dispatched",
    PEDIDO_bonificacion: "Bonus",
    PEDIDO_unidad_medida: "Unit of measure",
    PEDIDO_porcentaje_descuento: "Discount Percentage",
    PEDIDO_intereses: "Interest expense",
    PEDIDO_neto: "Net amount",
    PEDIDO_iva_reducido: "Reduced VAT",
    PEDIDO_periodo: "Period",
    PEDIDO_rango: "Range",
    PEDIDO_producto_missing: "Enter a product",
    PEDIDO_plazo_pago_missing: "Enter a payment term",
    PEDIDO_success: "Successful operation",
    PEDIDO_importe: "Amounts expressed in",
    PEDIDO_detalles: "Order details",
    PEDIDO_cantidad_item: "Quantity of items",
    PEDIDO_filtroFaltanDespachar: "Missing dispatch",
    PEDIDO_sin_confirmar: "Amount of unconfirmed orders",
    PEDIDO_eliminar_mensaje: "Do you want to delete the order?",
    PEDIDO_eliminar: "Delete order",
    PEDIDO_descargar_reporte_pdf: "Download pdf",
    PEDIDO_descargar_reporte_excel: "Download excel",

    PEDIDO_importar_subtitle: "Import details",
    PEDIDO_importar_msg: "Import details from an EXCEL file",
    PEDIDO_importar_seleccione_btn: "Select",
    PEDIDO_importar_importarBtn: "IMPORT",
    PEDIDO_importar_procesandoMsg: "Processing file",
    PEDIDO_importar_filasProcesadas: "ROWS PROCESSED",
    PEDIDO_importar_filasExitosas: "SUCCESSFUL ROWS",
    PEDIDO_importar_filasConError: "ROWS WITH ERROR",
    PEDIDO_importar_nuevaImportacionBtn: "NEW IMPORT",
    PEDIDO_importar_ejemplo_archivo: "See example file",
    PEDIDO_importar_ejemplo_titulo: "Import example",
    PEDIDO_importar_ejemplo_indicaciones:
      "The file must be in the format shown in the image and must be of the type .xlsx or .xls",

    PEDIDO_error_importar_formato_incorrecto: "Row [fila]: Incorrect format.",
    PEDIDO_error_importar_cantidad_cero: "Row [fila]: Zero quantity.",
    PEDIDO_error_importar_error_insercion: "Data insertion error.",
    PEDIDO_error_importar_cantidad_celdas:
      "Row [fila]: Incorrect number of cells.",
    PEDIDO_error_importar_no_admite_decimales:
      "Row [fila]: The product does not support decimals.",
    PEDIDO_error_importar_producto_inexistente:
      "Row [fila]: Non-existent product key.",
    PEDIDO_errores_importacion_titulo: "Import errors",
    PEDIDO_error_importar: "[codigo]: [mensaje]",

    PEDIDO_confirmar_title: "Confirm order",
    PEDIDO_confirmarPedidoBtn: "Confirm order",
    PEDIDO_editarPedidoBtn: "Edit order",
    PEDIDO_confirmando_pedido: "Confirm order",
    PEDIDO_confirmado: "Confirmed order",
    PEDIDO_confirmado_success: "The order was successfully confirmed",
    PEDIDO_volverAIngresoBtn: "Back to entry",

    /* Productos */
    PRODUCTO_productos: "Products",
    PRODUCTO_productos_seleccionados: "Selected products",
    PRODUCTO_eliminar: "Delete Product",
    DETALLE_eliminar: "Delete Detail",
    PRODUCTO_eliminar_mensaje: "Do you want to delete the product [codigo]?",
    DETALLE_eliminar_mensaje: "Do you want to delete the detail [codigo]?",
    PRODUCTO_agregar_repetido_mensaje:
      "The product [codigo] is already added. Do you want to continue?",
    PRODUCTO_estado: "[leyenda]",
    PRODUCTO_equipo: "Equipment",
    PRODUCTO_repuesto: "Replacement",
    PRODUCTO_detalle: "Product detail",
    PRODUCTO_agregar: "Add product",
    PRODUCTO_precio_unitario: "Unit price",
    PRODUCTO_agregar_producto: "Enter a product by selecting ",
    PRODUCTO_agregar_producto_cantidad_cero: "The quantity can't be zero.",
    PRODUCTO_agregar_producto_error: "It is not possible to add",
    PRODUCTO_nota_tecnica: "Technical note",
    PRODUCTO_cantidad_encontrados: "[cantidad] products found",
    // filtros de producto busqueda avanzada
    PRODUCTO_sin_tipo: "No [tipo] found",
    PRODUCTO_tipo_lineas: "lines",
    PRODUCTO_tipo_propiedades: "properties",

    /* Archivos */
    ARCHIVOS_archivos: "Files",
    ARCHIVOS_nombre: "Name",
    ARCHIVOS_path: "File",
    ARCHIVOS_incluir_archivos_publicos: "Include public files",
    ARCHIVOS_nuevo_archivo: "New file",
    ARCHIVOS_editar_archivo: "Edit file",
    ARCHIVOS_archivo_guardado: "File saved successfully",
    ARCHIVOS_tipo: "Type",
    ARCHIVOS_archivo: "File",
    ARCHIVOS_carpeta: "Folder",
    ARCHIVOS_link: "Link",
    ARCHIVOS_abrirLink: "Open link",
    ARCHIVOS_seleccionTipo: "Select the file type",
    ARCHIVOS_ingresoLink: "Enter the link",
    ARCHIVOS_descripcion: "Description",
    ARCHIVOS_ubicacion: "Location",
    ARCHIVOS_publico: "Public",
    ARCHIVOS_datos_archivo: "File data",
    ARCHIVOS_permisos_perfiles: "Permissions: profiles",
    ARCHIVOS_permisos_usuarios: "Permissions: users",
    ARCHIVOS_nombre_missing: "Enter the file name",
    ARCHIVOS_descripcion_missing: "Enter a file description",
    ARCHIVOS_fecha_vencimiento_missing: "Enter a file expiration date",
    ARCHIVOS_archivo_missing: "You must upload a file",
    ARCHIVOS_link_missing: "You must provide a link",
    ARCHIVOS_ubicacion_missing: "Enter the file's location",
    ARCHIVO_success: "File saved successfully",
    ARCHIVOS_descargar: "Download",
    ARCHIVOS_fecha_vencimiento: "Due date",
    ARCHIVOS_fecha_creacion: "Creation date",
    ARCHIVOS_eliminar: "Delete file",
    ARCHIVOS_eliminar_carpeta: "Delete folder",
    ARCHIVOS_eliminar_mensaje: 'Do you want to delete the file "[titulo]"?',
    ARCHIVOS_carpeta_eliminar_mensaje:
      'Do you want to delete the folder "[titulo]"?',
    ARCHIVOS_listas_todos: "All",
    ARCHIVOS_listas_elegidos: "Chosen",
    ARCHIVOS_perfiles_filtro_placeholder: "Search profiles",
    ARCHIVOS_usuarios_filtro_placeholder: "Search users",
    ARCHIVOS_heredar_permisos: "Inherit permissions",
    ARCHIVOS_es_archivo: "Is file",
    ARCHIVOS_carpeta_vacia: "There are no files to display",
    ARCHIVOS_error_descarga: "Error: file could not be downloaded",

    /* Noticias */
    HOME_avisos_importantes: "Notifications",
    HOME_avisos_alertas: "Alerts",
    HOME_avisos_advertencias: "Warnings",
    HOME_avisos_informacion: "Information",
    NOTICIAS_empty_state: "There are no news to show",
    NOTICIAS_leer_mas: "READ MORE",
    NOTICIAS_nueva_noticia: "News",
    NOTICIAS_noticias: "News",
    NOTICIAS_titulo: "Title",
    NOTICIAS_copete: "Pompadour",
    NOTICIAS_cuerpo: "Body",
    NOTICIAS_imagen_principal: "Main image",
    NOTICIAS_titulo_missing: "Enter the title",
    NOTICIAS_copete_missing: "Enter the pompadour",
    NOTICIAS_cuerpo_missing: "Enter the body",
    NOTICIAS_success: "Successful operation",
    NOTICIAS_error: "An error occurred while trying to save the news",
    NOTICIAS_registrado_por: "Registered by",
    NOTICIAS_estado: "Status",
    NOTICIAS_fecha_registro: "Registry date",
    NOTICIAS_fecha_publicacion: "Published date",
    NOTICIAS_seleccionar_estado: "Select",
    NOTICIAS_estado_borrador: "Draft",
    NOTICIAS_estado_publicado: "Published",
    NOTICIAS_estado_eliminado: "Removed",
    NOTICIAS_publicar: "Publish",
    NOTICIA_publicar_mensaje: "Do you want to publish the news [titulo]?",
    NOTICIA_publicar: "Publish news",
    NOTICIA_eliminar_mensaje: "Do you want to delete the news [titulo]?",
    NOTICIA_eliminar: "Delete news",

    /* Garantias */
    GARANTIAS_filtros: "Filters",
    GARANTIAS_ns: "Serial number / Lot / Code",
    GARANTIAS_numero_serie: "Serial number",
    GARANTIAS_ns_a_registrar: "Serial number to register",
    GARANTIAS_canje: "Request exchange",
    GARANTIAS_asociar_elementos:
      "Do you want to associate this element with another serial number?",
    GARANTIAS_fecha_instalacion: "Instalation date",
    GARANTIAS_ns_asoc: "Associated element serial number",
    GARANTIAS_noEsCanjeable: "It is not exchangeable",
    GARANTIAS_patente: "Patent",
    GARANTIAS_tiene_patente: "Has a patent?",
    GARANTIAS_nro_patente: "Patent number",
    GARANTIAS_marca_modelo: "Brand and model",
    GARANTIAS_marca_modelo_unidad: "Unit of the brand and Model",
    GARANTIAS_datos_usuario: "User / company data",
    GARANTIAS_usuario: "User",
    GARANTIAS_razon_nombre: "Company name / name and surname",
    GARANTIAS_incl_prod_asoc: "Include associated products",
    GARANTIAS_en_garantia: "In warranty",
    GARANTIAS_sin_garantia: "No warranty",
    GARANTIAS_telefono: "Phone number",
    GARANTIAS_instalado: "Installed",
    GARANTIAS_vence: "Warranty expires",
    GARANTIAS_cod_prod: "Code Product",
    GARANTIAS_garantia: "Warranty",
    GARANTIAS_garantia_adic: "Additional warranty",
    GARANTIAS_registrado_por: "Registered by",
    GARANTIAS_servicio_oficial: "Official service",
    GARANTIAS_producto_descripcion: "Description",
    GARANTIAS_meses: "months",
    GARANTIAS_registro_instalacion: "Installation log",
    GARANTIAS_registro_exito: "Installation logged successfully",
    GARANTIAS_datos_equipo: "Equipment / element data",
    GARANTIAS_ti_canje: "Exchange",
    GARANTIAS_venc_garantia_periodo: "Period",
    GARANTIAS_venc_garantia_rango: "Range",
    GARANTIAS_venc_garantia_meses_1: "Expire in 1 month",
    GARANTIAS_venc_garantia_meses_3: "Expire in 3 months",
    GARANTIAS_venc_garantia_meses_menos_1: "Expired 1 month ago",
    GARANTIAS_venc_garantia_meses_menos_12: "Expired 1 year ago",

    /* Solicitudes de Servicio */
    SOLICITUD_btn_editar: "Edit",
    SOLICITUD_btn_borrar: "Delete",
    SOLICITUD_btn_anular: "Cancel",
    SOLICITUD_btn_desasociar: "Disassociate",
    SOLICITUDES_solicitud: "Request Number [nro_solicitud]",
    SOLICITUDES_solicitud_servicio: "Service request",
    SOLICITUDES_solicitud_servicio_guardada: "Request saved successfully",
    SOLICITUDES_nro_solicitud: "Request number",
    SOLICITUDES_ns: "Serial number",
    SOLICITUDES_clave: "Code",
    SOLICITUDES_nro_remito: "Delivery number",
    SOLICITUDES_instancia: "Instance",
    SOLICITUDES_tipo_servicio: "Type",
    SOLICITUDES_check_garantia: "Warranty",
    SOLICITUDES_check_reparacion: "Repair",
    SOLICITUDES_check_canje: "Exchange",
    SOLICITUDES_label_observaciones: "Clarification of fault / Observations",
    SOLICITUDES_placeholder_observaciones: "Description...",
    SOLICITUDES_motivo: "Reason",
    SOLICITUDES_descripcion_vacia: "No description available",
    SOLICITUDES_ultimo_mes: "Last month",
    SOLICITUDES_ultimos_3_meses: "Last 3 months",
    SOLICITUDES_ultimo_anio: "Last year",
    SOLICITUDES_confirmado_periodo: "Period",
    SOLICITUDES_confirmado_rango: "Range",
    SOLICITUDES_borrar_solicitud_titulo: "Delete request",
    SOLICITUDES_observaciones1: "Description of image 1",
    SOLICITUDES_observaciones2: "Description of image 2",
    SOLICITUDES_observaciones3: "Description of image 3",

    SOLICITUDES_nro_serie_missing: "Please enter a valid serial number",
    SOLICITUDES_nro_serie_asociado_missing:
      "Please enter a valid associated item serial number",
    SOLICITUDES_observaciones_missing: "Enter the fault description",
    SOLICITUDES_patente_missing: "Enter the patent",
    SOLICITUDES_marca_modelo_missing: "Enter the brand and model",
    SOLICITUDES_motivo_missing: "Select the reason for the exchange",
    SOLICITUDES_alta_error:
      "Error trying to save service request (error: [errorCode])",
    SOLICITUDES_alta_success:
      "Successful operation. Number of request generated: [nro_solicitud]",
    SOLICITUDES_edicion_success:
      "The service request was successfully modified",
    SOLICITUDES_borrar_solicitud_mensaje:
      "Do you want to delete the request number [nro_solicitud]?",

    /* Asociación a remitos */
    SOLICITUD_REMITO_btn_asociar_remito: "Associate with delivery paper",
    SOLICITUD_REMITO_asociar_remito: "Associate with delivery paper",
    SOLICITUD_REMITO_nro_remito_input: "Enter the delivery number",
    SOLICITUD_REMITO_nro_remito: "Delivery number",

    SOLICITUD_REMITO_nro_sol: "Service request",
    SOLICITUD_REMITO_ns: "Serial number",
    SOLICITUD_REMITO_clave: "Code",
    SOLICITUD_REMITO_descripcion: "Description",
    SOLICITUD_REMITO_servicio_oficial: "Official service",
    SOLICITUD_REMITO_instancia: "Instance",
    SOLICITUD_REMITO_tipo_servicio: "Type",
    SOLICITUD_REMITO_anular_solicitud: "Cancel request",

    SOLICITUD_REMITO_solicitud_no_seleccionado:
      "You must select at least one request",
    SOLICITUD_REMITO_confirmacion_titlo: "Confirm association",
    SOLICITUD_REMITO_confirmacion_mensaje:
      "Associate requests with the delivery number [nro_remito]?",
    SOLICITUD_REMITO_exito:
      "Requests associated to the delivery number [nro_remito]",

    SOLICITUD_REMITO_anular_solicitud_titulo: "Cancel service request",
    SOLICITUD_REMITO_anular_solicitud_mensaje:
      "Do you want to cancel the service request [nro_solicitud]?",

    SOLICITUD_REMITO_desasociar_remito_titulo: "Disassociate delivery",
    SOLICITUD_REMITO_desasociar_remito_mensaje:
      "Do you want to disassociate the request [nro_solicitud] with the delivery number [nro_remito]?",

    /* Firmar Remitos */
    NAVBAR_firmarRemitos: "Sign Remittances",
    FIRMAR_REMITOS_titulo: "Sign Remittances",
    FIRMAR_REMITOS_filtro_id: "Remittance Number",
    FIRMAR_REMITOS_filtro_id_placeholder: "Search by number...",
    FIRMAR_REMITOS_filtro_estado: "Status",
    FIRMAR_REMITOS_filtro_firmados: "Signed",
    FIRMAR_REMITOS_filtro_no_firmados: "Not Signed",
    FIRMAR_REMITOS_sin_firmar: "Unsigned",
    FIRMAR_REMITOS_firmados: "Signed",
    FIRMAR_REMITOS_tabla_fecha: "Date",
    FIRMAR_REMITOS_tabla_tipo: "Type",
    FIRMAR_REMITOS_tabla_documento: "Document",
    FIRMAR_REMITOS_tabla_remito: "Remittance",
    FIRMAR_REMITOS_tabla_nro: "Nro.",
    FIRMAR_REMITOS_tabla_cant_items: "Qty. Items",
    FIRMAR_REMITOS_tabla_por: "Signed by",
    FIRMAR_REMITOS_tabla_el: "Signed on",
    FIRMAR_REMITOS_tabla_firma_notas: "Note",
    FIRMAR_REMITOS_tabla_conforme: "Conforming",
    FIRMAR_REMITOS_ver_remito: "View Remittance",
    FIRMAR_REMITOS_tabla_acciones: "Actions",
    FIRMAR_REMITOS_descargar_pdf: "Download PDF",
    FIRMAR_REMITOS_firmar: "Sign remittance",
    FIRMAR_REMITOS_modal_titulo: "Sign Remittance",
    FIRMAR_REMITOS_modal_confirmacion: "Confirm total receipt of goods from the remittance.",
    FIRMAR_REMITOS_modal_notas: "Note",
    FIRMAR_REMITOS_modal_notas_placeholder: "Enter note...",
    FIRMAR_REMITOS_modal_confirmar: "Sign",
    FIRMAR_REMITOS_modal_confirmar_conforme: "Sign in agreement",
    FIRMAR_REMITOS_modal_confirmar_no_conforme: "Sign not in agreement",
    FIRMAR_REMITOS_nota_requerida_no_conforme: "A note must be attached to sign not in agreement.",
    FIRMAR_REMITOS_pdf_descargado: "PDF downloaded successfully",
    FIRMAR_REMITOS_error_descargar: "Error downloading PDF",
    FIRMAR_REMITOS_firmado_exito: "Remittance signed successfully",
    FIRMAR_REMITOS_error_firmar: "Error signing remittance",
    FIRMAR_REMITOS_error_cargar: "Error loading remittances",

    /* Foro */
    FORO_nuevo_post: "New post",
    FORO_titulo: "Title",
    FORO_descripcion: "Description",
    FORO_imagenes: "Images",
    FORO_titulo_missing: "Enter the title",
    FORO_descripcion_missing: "Enter the description",
    FORO_exito: "The post was generated correctly",
    FORO_error: "Error generating the post",
    FORO_missing: "Forum entry not found",
    FORO_archivar: "Store",
    FORO_confirmado: "Confirmed",
    FORO_archivado: "Stored",
    FORO_responder: "Reply",
    FORO_comentar: "Comment",
    FORO_comentario_placeholder: "Comment...",
    FORO_permitir_imagenes: "Allow loading images",
    FORO_foros: "Posts",
    FORO_imagen_grande: "The image uploaded is too big",

    /* Foro comentario */
    FORO_comentario_missing: "Enter a comment",
    FORO_comentario_exito: "Comment generated correctly",
    FORO_comentario_error: "Error generating the comment",

    /* Instancias */
    INSTANCIA_PENDIENTE_ASOCIAR: " Pending to associate with delivery",
    INSTANCIA_PENDIENTE_ENVIAR: " Pending to send Colven",
    INSTANCIA_ENVIADO: " Sent to Colven",
    INSTANCIA_PROCESO: " In process",
    INSTANCIA_HISTORICO: " In historical",

    /* File upload */
    FILE_UPLOAD_cargar_imagen: "Upload image",
    FILE_UPLOAD_cargar_archivo: "File upload",
    FILE_UPLOAD_limite_exedido: "The number of files allowed has been exceeded",
    FILE_UPLOAD_extension_no_permitida: "The file extension is not allowed",

    /* Presupuestos */
    PRESUPUESTO_pedido: "Budget",
    PRESUPUESTO_instancia: "Instance",
    PRESUPUESTO_ingresadoPor: "Entered by",
    PRESUPUESTO_instancia_ingresado: "Entered",
    PRESUPUESTO_instancia_proceso: "In process",
    PRESUPUESTO_instancia_historico: "Historical",
    PRESUPUESTO_instancia_confirmado: "Confirmed",
    PRESUPUESTO_numero: "Number",
    PRESUPUESTO_numero_placeholder: "Enter the number",
    PRESUPUESTO_periodo_meses_1: "Last month",
    PRESUPUESTO_periodo_meses_2: "Last two months",
    PRESUPUESTO_periodo_meses_3: "Last three monts",
    PRESUPUESTO_periodo_ultimos_2anios: "Last two years",
    PRESUPUESTO_eliminar_mensaje: "Do you want to delete the budget?",
    PRESUPUESTO_eliminar: "Delete budget",
    PRESUPUESTO_inicializando_cabecera: "Initializing header",
    PRESUPUESTO_numero_presupuesto: "Budget number",
    PRESUPUESTO_plazo_pago: "Payment deadline",
    PRESUPUESTO_nota_comercial: "Commercial note",
    PRESUPUESTO_nuevo_presupuesto: "New Budget",
    PRESUPUESTO_importe_final: "Final amount",
    PRESUPUESTO_sin_impuesto_ingresos_brutos:
      "Gross Income Tax is not included",
    PRESUPUESTO_referencia_base_dolar:
      "(+) Dollar-based prices, at the time of invoicing it will be updated with the price of the day before the invoice date of the Banco Nación seller type",
    PRESUPUESTO_subtotal: "Subtotal",
    PRESUPUESTO_iva: "VAT",
    PRESUPUESTO_despachado: "Dispatched",
    PRESUPUESTO_bonificacion: "Bonus",
    PRESUPUESTO_unidad_medida: "Unit of measure",
    PRESUPUESTO_porcentaje_descuento: "Discount Percentage",
    PRESUPUESTO_intereses: "Interest expense",
    PRESUPUESTO_neto: "Net amount",
    PRESUPUESTO_iva_reducido: "Reduced VAT",
    PRESUPUESTO_periodo: "Period",
    PRESUPUESTO_rango: "Range",
    PRESUPUESTO_producto_missing: "Enter a product or a detail",
    PRESUPUESTO_razon_social_missing: "Enter a Business Name",
    PRESUPUESTO_domicilio_missing: "Enter an Address",
    PRESUPUESTO_fecha_vigencia_missing: "Enter a Effective Name",
    PRESUPUESTO_plazo_pago_missing: "Enter a payment term",
    PRESUPUESTO_fecha_vigencia_incorrect: "Incorrect Effective Date",
    PRESUPUESTO_success: "Successful operation",
    PRESUPUESTO_importe: "Amounts expressed in",
    PRESUPUESTO_detalles: "Budget details",
    PRESUPUESTO_domicilio: "Address",
    PRESUPUESTO_vigencia: "Effective Date",
    PRESUPUESTO_razon_social: "Business Name",
    PRESUPUESTO_razon_social_placeholder: "Enter the Business Name",
    PRESUPUESTO_domicilio_placeholder: "Enter the Address",
    PRESUPUESTO_mano_obra: 'Workforce:',
    PRESUPUESTO_mo: 'W.F.:',

    PRESUPUESTO_importar_subtitle: "Import details",
    PRESUPUESTO_importar_msg: "Import details from an EXCEL file",
    PRESUPUESTO_importar_seleccione_btn: "Select",
    PRESUPUESTO_importar_importarBtn: "IMPORT",
    PRESUPUESTO_importar_procesandoMsg: "Processing file",
    PRESUPUESTO_importar_filasProcesadas: "ROWS PROCESSED",
    PRESUPUESTO_importar_filasExitosas: "SUCCESSFUL ROWS",
    PRESUPUESTO_importar_filasConError: "ROWS WITH ERROR",
    PRESUPUESTO_importar_nuevaImportacionBtn: "NEW IMPORT",
    PRESUPUESTO_importar_ejemplo_archivo: "See example file",
    PRESUPUESTO_importar_ejemplo_titulo: "Import example",
    PRESUPUESTO_importar_ejemplo_indicaciones:
      "The file must be in the format shown in the image and must be of the type .xlsx or .xls",

    PRESUPUESTO_error_importar_formato_incorrecto:
      "Row [fila]: Incorrect format.",
    PRESUPUESTO_error_importar_cantidad_cero: "Row [fila]: Zero quantity.",
    PRESUPUESTO_error_importar_error_insercion: "Data insertion error.",
    PRESUPUESTO_error_importar_cantidad_celdas:
      "Row [fila]: Incorrect number of cells.",
    PRESUPUESTO_error_importar_no_admite_decimales:
      "Row [fila]: The product does not support decimals.",
    PRESUPUESTO_error_importar_producto_inexistente:
      "Row [fila]: Non-existent product key.",
    PRESUPUESTO_errores_importacion_titulo: "Import errors",
    PRESUPUESTO_error_importar: "[codigo]: [mensaje]",

    PRESUPUESTO_confirmar_title: "Confirm budget",
    PRESUPUESTO_confirmarPresupuestoBtn: "Confirm budget",
    PRESUPUESTO_editarPresupuestoBtn: "Edit budget",
    PRESUPUESTO_confirmando_presupuesto: "Confirm budget",
    PRESUPUESTO_confirmado: "Confirmed budget",
    PRESUPUESTO_confirmado_success: "The budget was successfully confirmed",
    PRESUPUESTO_volverAIngresoBtn: "Back to entry",

    PRESUPUESTO_agregar_detalle: "Add detail",
    PRESUPUESTO_productos_detalles_seleccionados:
      "Selected products and details",
    PRESUPUESTO_agregar_producto_detalle:
      "Enter a product or a detail by selecting ",
    PRESUPUESTO_detalle: "Detail",
    PRESUPUESTO_detalle_descripcion_placeholder:
      "Enter a description for the detail",
    PRESUPUESTO_detalle_precio_placeholder: "Unit price",
    PRESUPUESTO_detalle_IVA_label: "VAT type",
    PRESUPUESTO_detalle_IVA_21: "VAT taxed 21%",
    PRESUPUESTO_detalle_IVA_10: "VAT reduced 10,5%",
    PRESUPUESTO_detalle_IVA_0: "VAT free",
    PRESUPUESTO_detalle_label_cantidad: "Quantity",
    PRESUPUESTO_detalle_nota_tecnica: "Technical note",
    PRESUPUESTO_detalle_nota_tecnica_placeholder: "Enter a technical note",
    PRESUPUESTO_descripcion_editar_placeholder: "Description",
    PRESUPUESTO_precio_editar_placeholder: "Price",
    PRESUPUESTO_descargar_reporte: "Download",

    PRESUPUESTO_descripcion_error: "Enter the detail description",
    PRESUPUESTO_precio_unitario_error: "Enter the unit price",
    PRESUPUESTO_cantidad_error: "Enter a non-zero quantity",

    /* Pedidos a Distribuidores */
    PEDIDOADISTRIBUIDORES_pedido: "Orders to Distributor",
    PEDIDOADISTRIBUIDORES_instancia_ingreso: "Entry",
    PEDIDOADISTRIBUIDORES_instancia_confirmado: "Confirmed",
    PEDIDOADISTRIBUIDORES_instancia_proceso: "In Process",
    PEDIDOADISTRIBUIDORES_instancia_historico: "Historical",
    PEDIDOADISTRIBUIDORES_instancia_seleccionado: "Selected",

    /* Pedidos Subagentes */
    PEDIDOSUBAGENTE_pedido: "Subagents Orders",
    PEDIDOSUBAGENTE_instancia_ingreso: "Entry",
    PEDIDOSUBAGENTE_pasar_a_seleccionados: "Move to Selected",
    PEDIDOSUBAGENTE_pasar_a_historicos: "Move to History",
    PEDIDOSUBAGENTE_pasar_a_seleccionados_msg: "Do you want to move the orders to the 'Selected for Processing' instance?",
    PEDIDOSUBAGENTE_pasar_a_historicos_msg: "Do you want to move the orders to the 'Historical' instance?",
    PEDIDOSUBAGENTE_seleccione_pedido: "You must select at least one order",
    PEDIDOSUBAGENTE_seleccione_todos: "Select all",
    PEDIDOSUBAGENTE_exportar: "Export",
    PEDIDOSUBAGENTE_exportar_excel_consolidado: "Export to consolidated excel",
    PEDIDOSUBAGENTE_exportar_excel_detalles: "Export to excel details",
    PEDIDOSUBAGENTE_pedido_consolidados: "Consolidated Subagents Orders",
    PEDIDOSUBAGENTE_pedido_detalles: "Details Subagents Orders",
    PEDIDOSUBAGENTE_cliente: "Client",

    /*Pendientes*/
    PENDIENTES_cuenta_corrientes: "Current Account",
    PENDIENTES_agrupar_por: "Group Data by:",
    PENDIENTES_cc_placeholer: "Select a Current Account",
    PENDIENTES_semana: "Week",
    PENDIENTES_mes: "Month",
    PENDIENTES_sin_agrupar: "Ungrouped",
    PENDIENTES_vencimiento: "Expiration",
    PENDIENTES_vence_el: "Due Date",
    PENDIENTES_tipo: "Type",
    PENDIENTES_serie: "Serie",
    PENDIENTES_suc: "Branch",
    PENDIENTES_punto_venta: "Point Sale",
    PENDIENTES_numero: "Number",
    PENDIENTES_plazo_pago: "Payment Term",
    PENDIENTES_fecha_documento: "Doc. Date",
    PENDIENTES_debe_pendiente: "Pending Debit",
    PENDIENTES_haber_pendiente: "Pending Credit",
    PENDIENTES_cuotas: "Due",
    PENDIENTES_debe: "Debit",
    PENDIENTES_haber: "Credit",
    PENDIENTES_desde: "From",
    PENDIENTES_hasta: "To",
    PENDIENTES_descargar_excel: "Export to Excel",
    PENDIENTES_estado_vencimiento: "Due Status",
    PENDIENTES_todos: "All",
    PENDIENTES_a_vencer: "To Be Due",
    PENDIENTES_vencido: "Overdue",
    GETCUENTASCORRIENTES_error: "There was an error getting the checking accounts",
    PENDIENTES_exportar: "Export",
    PENDIENTES_total_debe: "Total debe",
    PENDIENTES_total_haber: "Total haber",
    PENDIENTES_buscar: "Select Checking Account and Grouping to start the search",
    PENDIENTES_datos_agrupados_por: "Data grouped by",
    PENDIENTES_error_exportar1: "Select a current account and grouping to download excel",

    /*Mensaje para mostrar en la tabla cuando no hay datos*/
    EL_TABLE_sin_datos: "No data",

    /* Errores de autorización */
    ERROR_CODE_AUTH_0: "Successful operation", // OK
    ERROR_CODE_AUTH_1: "Invalid application", // AplicacionInvalida
    ERROR_CODE_AUTH_2: "Invalid username and / or password", // UsuarioContraseniaInvalidos
    ERROR_CODE_AUTH_3: "LDAP server offline", // ServidorLDAPSinConexion
    ERROR_CODE_AUTH_4: "User exceeds number of installed instances", // UsuarioExcedeCantidadInstanciasInstaladas
    ERROR_CODE_AUTH_5: "User without company", // UsuarioSinEmpresa
    ERROR_CODE_AUTH_6: "Company without country", // EmpresaSinPais
    ERROR_CODE_AUTH_7: "LDAP Server General Error", // ServidorLDAPErrorGeneral
    ERROR_CODE_AUTH_8: "Error updating user", // UsuarioErrorAlActualizar
    ERROR_CODE_AUTH_9: "Parameter error", // ErrorDeParametros
    ERROR_CODE_AUTH_10: "Password change is not allowed", // UsuarioADNoSePermiteCambiarContrasenia
    ERROR_CODE_AUTH_11:
      "Expired or invalid token, please reset the password again", // TokenInvalido
    ERROR_CODE_AUTH_12: "Invalid password length", // LongitudContraseniaInvalido
    ERROR_CODE_AUTH_13: "Error sending mail", // EnviarMailError
    ERROR_CODE_AUTH_14: "User without email", // UsuarioSinEmail
    ERROR_CODE_AUTH_17: "Password recovery for the user is not allowed", // UsuarioADNoSePermiteCambiarContrasenia

    /* Error Codes GARANTÍAS*/
    "ERROR_CODE_-1": "An unexpected error occurred",
    "ERROR_CODE_-2": "Invalid application",
    "ERROR_CODE_-3": "Invalid username and / or password",
    "ERROR_CODE_-4": "LDAP server offline",
    "ERROR_CODE_-5": "User exceeds number of installed instances",
    "ERROR_CODE_-6": "User without company",
    "ERROR_CODE_-7": "Company without country",
    "ERROR_CODE_-8": "LDAP Server General Error",
    "ERROR_CODE_-9": "Error updating user",
    "ERROR_CODE_-10": "Parameter error",
    "ERROR_CODE_-11": "Password change is not allowed",
    "ERROR_CODE_-12": "Error copying files",

    /* Error Codes PEDIDOS */
    "ERROR_CODE_-100": "Enter the profile code",
    "ERROR_CODE_-101": "Enter the profile description",
    "ERROR_CODE_-102": "Enter the message to send",
    "ERROR_CODE_-103": "Error retrieving business photo",
    "ERROR_CODE_-104": "Error sending email",

    /* Error Codes NOTICIAS */
    "ERROR_CODE_-105": "Error saving the news",
    "ERROR_CODE_-106": "The news does not exist in the database",
    "ERROR_CODE_-107": "Select the status of the news",
    "ERROR_CODE_-108": "Enter the title of the news",
    "ERROR_CODE_-109": "Enter the pompadour of the news",
    "ERROR_CODE_-110": "Enter the body of the news",

    /* Error Codes FORO */
    "ERROR_CODE_-111": "Failed to save forum post",
    "ERROR_CODE_-112": "Forum entry does not exist in the database",
    "ERROR_CODE_-113": "Enter the title of the forum post",
    "ERROR_CODE_-114": "Enter the description of the forum post",

    "ERROR_CODE_-115": "Error saving forum comment",
    "ERROR_CODE_-116": "Forum comment does not exist in the database",
    "ERROR_CODE_-117": "Failed to retrieve parent of forum comment",
    "ERROR_CODE_-118": "Enter the forum comment",
    "ERROR_CODE_-135": "This forum does not allow uploading images",

    "ERROR_CODE_-119": "Select the area to send the email to",
    "ERROR_CODE_-120": "Enter the message to send",
    "ERROR_CODE_-121": "Error sending email",

    /* Error Codes ARCHIVOS */
    "ERROR_CODE_-124": "The file does not exist in the database",
    "ERROR_CODE_-125": "You must upload a file",
    "ERROR_CODE_-126": "Enter the file name",
    "ERROR_CODE_-127": "Enter a file description",
    "ERROR_CODE_-128": "File save error",
    "ERROR_CODE_-136": "Error creating folder",
    "ERROR_CODE_-137":
      "Failed to delete folder. Verify that it doesn't contain files",

    /* Error Codes Pedido */
    "ERROR_CODE_-122": "The order does not exist in the database",
    "ERROR_CODE_-123": "The order is duplicated in the database",
    "ERROR_CODE_-129": "The imported file could not be recovered",

    /* Errores Resumen de cuenta */
    "ERROR_CODE_-139": 'The receipt is duplicated',
    "ERROR_CODE_-140": 'The bill is duplicated',
    "ERROR_CODE_-141": "The bill doesn't exist",
    /* Errores Generales */
    ERROR_CODE_NETWORK: "Network error",
    ERROR_CODE_UNAUTHORIZED:
      "You do not have permissions to perform the requested operation",
    ERROR_CODE_999: "Not implemented",
    ERROR_CODE_9998: "Not implemented",
    ERROR_CODE_9999: "Error not contemplated",

    "ERROR_CODE_-131": "The extension file is not allowed"
  },
  es: {
    /* General */
    GENERAL_titulo_bienvenida: "Bienvenido a ColvenNet",
    GENERAL_mensaje_bienvenida: "COLVEN S.A.",
    GENERAL_checkingCredentials: "Verificando credenciales",
    GENERAL_requiredField: "El campo no puede estar vacío",
    GENERAL_saveBtn: "Guardar",
    GENERAL_editBtn: "Editar",
    GENERAL_confirmBtn: "Confirmar",
    GENERAL_deleteBtn: "Eliminar",
    GENERAL_cancelBtn: "Cancelar",
    GENERAL_acceptBtn: "Aceptar",
    GENERAL_si: "Si",
    GENERAL_no: "No",
    GENERAL_filtrar: "filtrar",
    GENERAL_filtrarProductos: "Buscar producto por código o descripción",
    GENERAL_okBtn: "OK",
    GENERAL_exportBtn: "Exportar",
    GENERAL_importBtn: "Importar",
    GENERAL_success: "Operación exitosa",
    GENERAL_no_data: "No se encontraron datos",
    GENERAL_opcional: "Opcional",
    GENERAL_enviar: "Enviar",
    GENERAL_volver: "Volver",
    GENERAL_asociar: "Asociar",
    GENERAL_descargar: "Descargar",
    GENERAL_clean_filters: "Limpiar filtros",
    GENERAL_OPCION_TODOS: "< Todos >",
    GENERAL_Busqueda_Simple: "Búsqueda Simple",
    GENERAL_Busqueda: "Búsqueda",
    GENERAL_Busqueda_Avanzada: "Búsqueda Avanzada",
    GENERAL_nuevo: "Nuevo",
    GENERAL_desde: "Desde",
    GENERAL_hasta: "Hasta",
    GENERAL_resultado: "Resultados de búsqueda",
    GENERAL_fecha: "Fecha",
    GENERAL_subtotal: "Subtotal",
    GENERAL_descripcion: "Descripción",
    GENERAL_seleccione: "Seleccione",
    GENERAL_atencion: "Atención",
    GENERAL_agregar_continuar: "Agregar y Continuar",
    GENERAL_desea_cancelar: "¿Deseas cancelar?",
    GENERAL_cancelar_mensaje:
      "Es posible que los cambios que implementaste no se puedan guardar.",
    GENERAL_salir: "Salir",
    GENERAL_infoColven: "Oficina Central y Planta Industrial en Argentina",
    GENERAL_filtros: "Filtros",
    GENERAL_cargando: "Cargando",
    GENERAL_cantidadPaginas: "Página [paginaActual] de [totalPagina]",
    GENERAL_buscando: "Buscando",

    GENERAL_img_upload_btn: "Subir imagen",
    GENERAL_img_upload_btn_plural: "Subir imágenes",
    GENERAL_img_upload_error:
      "Ocurrió un error al tratar de cargar uno de los archivos",
    GENERAL_img_upload_limit: "El límite es de 3 archivos, seleccionaste ",
    GENERAL_img_remove_confirm: "¿Está seguro que desea remover ",

    GENERAL_missing_nro_serie: "Ingrese un número de serie válido.",
    GENERAL_missing_nro_serie_asoc:
      "Ingrese un NS del elemento asociado válido.",
    GENERAL_missing_fec_instalcion: "Falta completar la fecha de instalación",
    GENERAL_missing_rz_soc: "Falta completar la razón social.",
    GENERAL_missing_telefono: "Falta completar el teléfono.",
    GENERAL_missing_patente: "Falta completar la patente.",
    GENERAL_missing_marca_modelo: "Falta completar la marca y modelo.",
    GENERAL_missing_imagen_garantia: "Es necesario cargar las dos imagenes",

    /* Contacto */
    CONTACTO_contacto: "Contacto",
    CONTACTO_enviar: "Enviar a",
    CONTACTO_mensaje: "Mensaje",
    CONTACTO_missing_enviar:
      "Seleccione el departamento al cual enviar el mensaje",
    CONTACTO_missing_mensaje: "Ingrese el mensaje a enviar",
    CONTACTO_success: "El email se envió correctamente",
    CONTACTO_error: "Ocurrió un error al intentar enviar el email",
    CONTACTO_a_su_disposicion:
      "Estamos a disposición por cualquier duda o inconveniente:",

    /* Perfil */
    PERFIL_perfil: "Perfil",
    PERFIL_empty_state: "No hay datos para mostrar",
    PERFIL_empresa: "Empresa",
    PERFIL_razon_social: "Razón Social",
    PERFIL_domicilio: "Domicilio",
    PERFIL_localidad: "Localidad",
    PERFIL_cp: "CP",
    PERFIL_pcia_estado: "Pcia Estado",
    PERFIL_pais: "País",
    PERFIL_lineas: "Lineas que vende",
    PERFIL_tel_mail: "Teléfonos / Email",
    PERFIL_area: "Área",
    PERFIL_tipo: "Tipo",
    PERFIL_usado_para: "Usado Para",
    PERFIL_direcciones: "Direcciones",
    PERFIL_provincia: "Provincia",
    PERFIL_pcia_clave: "Pcia Clave",
    PERFIL_tel_direccion: "Teléfonos de esta dirección",
    PERFIL_tel_asoc: "Teléfonos Asociados",
    PERFIL_nro_mail: "Nro/Email",

    PERFIL_edicion: "Edición de perfil",
    PERFIL_instrucciones:
      "Indique a continuación el dato de su empresa que sugiere actualizar en nuestros registros:",
    PERFIL_editar: "Editar",
    PERFIL_mensaje: "Mensaje",
    PERFIL_mensaje_placeholder: "Datos que desea cambiar",
    PERFIL_upload_img: "Subir foto del negocio",
    PERFIL_missing_mensaje: "Ingrese el mensaje a enviar",
    PERFIL_success: "El email se envió correctamente",
    PERFIL_error: "Ocurrió un error al intentar enviar el email",

    /* Login */
    LOGIN_loginTitle: "Bienvenido a ColvenNet",
    LOGIN_user: "Usuario",
    LOGIN_email: "Email",
    LOGIN_password: "Contraseña",
    LOGIN_new_password: "Nueva contraseña",
    LOGIN_confirm_password: "Confirmar contraseña",
    LOGIN_password_mismatch: "Las contraseñas no coinciden",

    LOGIN_loginBtn: "INGRESAR",
    LOGIN_sendButton: "ENVIAR",
    LOGIN_confirmBtn: "CONFIRMAR",
    LOGIN_saveBtn: "GUARDAR",
    LOGIN_invalidLogin: "Usuario y/o contraseña inválidos",
    LOGIN_forgotPassword: "Olvidé mi contraseña",
    LOGIN_resetPasswordMsg:
      "Ingrese su nombre de usuario. Recibirá un email con instrucciones de cómo recuperar su contraseña.",
    LOGIN_contact: "Contacto",

    LOGIN_activeSesion: "Sesión activa",
    LOGIN_forceCloseBtn: "Forzar sesión",
    LOGIN_activeSessionMsg:
      "Ya existe una sesión activa para el usuario [USERNAME]. Sólo se permite una sesión activa por usuario.",
    LOGIN_activeSesionClosed: "Operación exitosa, ya puedes iniciar sesión",
    LOGIN_activeSesionError: "Error al forzar cierre de sesión",

    LOGIN_expiredPassword: "Contraseña vencida. Se requiere cambiar la contraseña.",

    /* 2FA */
    TWO_FACTOR_AUTHENTICATION_twoFactorAuthentication: "Doble factor de autenticación",
    TWO_FACTOR_AUTHENTICATION_scanQR: "Escanear código QR",
    TWO_FACTOR_AUTHENTICATION_enterCode: "Ingresar código",
    TWO_FACTOR_AUTHENTICATION_verify: "VERIFICAR",
    TWO_FACTOR_AUTHENTICATION_6DigitsCode: "Ingresar código de 6 dígitos",
    TWO_FACTOR_AUTHENTICATION_verifyError: "Código inválido",
    TWO_FACTOR_AUTHENTICATION_verifySuccess: "Código validado correctamente",
    TWO_FACTOR_AUTHENTICATION_codeSaved: "Código guardado correctamente",
    TWO_FACTOR_AUTHENTICATION_title: "Ingrese Código de Seguridad",
    TWO_FACTOR_AUTHENTICATION_message: "Ingrese el código de 6 dígitos en su aplicación de autenticación",
    TWO_FACTOR_AUTHENTICATION_explanation: "Utilizamos doble factor de autenticación para ofrecer mayor seguridad a su cuenta. Para ello, es necesario hacer los siguientes pasos: ",
    TWO_FACTOR_AUTHENTICATION_item1: "1. Descargar la aplicación Google Authenticator en su dispositivo móvil.",
    TWO_FACTOR_AUTHENTICATION_item2: "2. Escanear el código QR que se muestra a continuación.",
    TWO_FACTOR_AUTHENTICATION_item3: "3. Ingresar el código de 6 dígitos que se muestra en la aplicación Google Authenticator.",
    TWO_FACTOR_AUTHENTICATION_item4: "4. Si el codigo verifica se lo guardará asociandolo a su cuenta.",
    TWO_FACTOR_AUTHENTICATION_requiredField: "El campo debe tener 6 números",
    TWO_FACTOR_AUTHENTICATION_reasonToActivate: "Para ofrecer mayor seguridad a su cuenta puede activar el doble factor de autenticación usando la aplicacion Authenticator.",
    TWO_FACTOR_AUTHENTICATION_activateBtn: "ACTIVAR",
    TWO_FACTOR_AUTHENTICATION_deactivate2FA: "Desactivar doble factor de autenticacion",
    TWO_FACTOR_AUTHENTICATION_disableSuccess: "Doble factor de autenticación desactivado correctamente",
    TWO_FACTOR_AUTHENTICATION_disableError: "Error al desactivar doble factor de autenticación",
    TWO_FACTOR_AUTHENTICATION_disableConfirm: "¿Está seguro que desea desactivar el doble factor de autenticación?",
    TWO_FACTOR_AUTHENTICATION_disableBtn: "DESACTIVAR",
    TWO_FACTOR_AUTHENTICATION_disableTitle: "Desactivar doble factor de autenticación",


    /* Nuevo usuario */
    NEW_USER_userExists: "El usuario ya existe",
    NEW_USER_invalidUser: "Usuario inválido",
    NEW_USER_savePassordSuccess: "Contraseña guardada correctamente",

    /* Cambio de contraseña */
    CHANGE_PASS_changePassword: "Cambio de contraseña",
    CHANGE_PASS_currentPassword: "Contraseña actual",
    CHANGE_PASS_newPassword: "Contraseña nueva",
    CHANGE_PASS_repeatNewPassword: "Repetir contraseña actual",
    CHANGE_PASS_passwordNotEquals: "Las contraseñas no coinciden",
    CHANGE_PASS_changePasswordSuccess: "Cambio de contraseña exitoso",
    CHANGE_PASS_invalidPassword: "Contraseña inválida",
    CHANGE_PASS_errorOnChangePassword: "Error al actualizar la contraseña",
    CHANGE_PASS_emptyPassword: "La contraseña nueva no puede ser vacía",


    /* Recuperar contraseña */
    RETRIEVE_PASS_emailSent: "Email enviado",

    /* Sesión expirada */
    EXPIRED_SESION_title: "Sesión expirada",
    EXPIRED_SESION_msg:
      "La sesión ha expirado. Por favor ingrese su usuario y contraseña nuevamente",

    /* Navbar */
    NAVBAR_inicio: "Inicio",
    NAVBAR_productos: "Garantías",
    NAVBAR_cuentas: "Cuenta Corriente",
    NAVBAR_comunidad: "Comunidad",
    NAVBAR_pedidos: "Pedidos",
    NAVBAR_reg_instalacion: "Registros de instalación",
    NAVBAR_expire_warranty: "Garantías próximas a vencer",
    NAVBAR_solicitudes: "Solicitudes de servicios",
    NAVBAR_remitos: "Asociación a remitos",
    NAVBAR_noticias: "Noticias",
    NAVBAR_pagos: "Pagos",
    NAVBAR_foro: "Foro",
    NAVBAR_archivos: "Archivos",
    NAVBAR_contacto: "Contacto",
    NAVBAR_gestionNoticias: "Gestión de noticias",
    NAVBAR_presupuestos: "Presupuestos",
    NAVBAR_pedidosSubagentes: "Pedidos Subagentes",
    NAVBAR_pedidosDistribuidores: "Pedidos a Distribuidor",
    NAVBAR_pendientes: "Documentos Pendientes",
    NAVBAR_resumenDeCuenta: "Resumen de cuenta",
    NAVBAR_clientes: "Clientes",

    /* Resumen de cuenta */
    RESUMENDECUENTA_cuenta: "Cuenta",
    RESUMENDECUENTA_recibo: "Recibo",
    RESUMENDECUENTA_loading: "Obteniendo resumen",
    RESUMENDECUENTA_cuenta_sin_confirmar: "Sin confirmar",
    RESUMENDECUENTA_periodo_meses_1: "Último mes",
    RESUMENDECUENTA_periodo_meses_2: "Últimos 2 meses",
    RESUMENDECUENTA_periodo_meses_3: "Últimos 3 meses",
    RESUMENDECUENTA_periodo_ultimos_2anios: "Últimos 2 años",
    RESUMENDECUENTA_sin_confirmar: "Cantidad de documentos sin confirmar",
    RESUMENDECUENTA_tabla_fecha: "Fecha",
    RESUMENDECUENTA_tabla_documento: "Documentos",
    RESUMENDECUENTA_tabla_acciones: "Acciones",
    RESUMENDECUENTA_tabla_descripcion: "Descripción",
    RESUMENDECUENTA_tabla_debe: "Debe",
    RESUMENDECUENTA_tabla_haber: "Haber",
    RESUMENDECUENTA_tabla_totales: "Totales",
    RESUMENDECUENTA_tabla_diferencia_haber_debe: "Diferencia Haber - Debe:",
    RESUMENDECUENTA_label_documento_seleccionado: "Documento: ",
    RESUMENDECUENTA_tabla_cancelaciones_documento: "Documento",
    RESUMENDECUENTA_tabla_cancelaciones_cuoata: "Cuota",
    RESUMENDECUENTA_tabla_cancelaciones_vence: "Vence",
    RESUMENDECUENTA_tabla_cancelaciones_debe: "Debe",
    RESUMENDECUENTA_tabla_cancelaciones_cancelado: "Canceló",
    RESUMENDECUENTA_verRecibo: 'Ver recibo',
    RESUMENDECUENTA_descargarFactura: 'Descargar documento',
    RESUMENDECUENTA_verCancelaciones: 'Ver cancelaciones',
    RESUMENDECUENTA_descargar_excel: "Exportar a Excel",
    RESUMENDECUENTA_exportar: "Exportar",
    RESUMENDECUENTA_error_exportar1: "Seleccione Cuenta Corriente para descargar el excel",
    RESUMENDECUENTA_fecha: 'Fecha',
    RESUMENDECUENTA_cliClave: 'Clave',
    RESUMENDECUENTA_razonSocial: 'Razon social',
    RESUMENDECUENTA_CodigoEmpresa: 'Código de empresa',
    RESUMENDECUENTA_sucursal: 'Sucursal',
    RESUMENDECUENTA_importeTotal: 'Importe total',
    RESUMENDECUENTA_tipoDocumento: 'Tipo',
    RESUMENDECUENTA_numero: 'Número',
    RESUMENDECUENTA_banco: 'Banco',
    RESUMENDECUENTA_importe: 'Importe',
    RESUMENDECUENTA_concepto: 'Concepto',
    RESUMENDECUENTA_saldo: 'Saldo',
    RESUMENDECUENTA_montoSinImputar: 'Monto sin imputar',
    RESUMENDECUENTA_errorDescargaFactura: "No se pudo descargar la factura",
    RESUMENDECUENTA_errorObtencionRecibo: "No se pudo obtener el recibo",
    RESUMENDECUENTA_errorObtencionDocumentos: "No se pudo obtener los documentos",
    RESUMENDECUENTA_errorObtencionCancelaciones: "No se pudo obtener las cancelaciones",
    RESUMENDECUENTA_RealizarConsulta: 'Realizar consulta',
    RESUMENDECUENTA_clientes: "Clientes",
    RESUMENDECUENTA_clientes_placeholder: "Ingrese nombre del cliente",
    RESUMENDECUENTA_cuentas: "Cuentas",
    RESUMENDECUENTA_cuentas_placeholder: "Seleccione una Cuenta",
    RESUMENDECUENTA_errorObtencionClientes: "La lista de clientes no pudo ser obtenida",
    RESUMENDECUENTA_errorObtencionCuentas: "Las cuentas del cliente no pudieron ser obtenidas",

    /* Pedidos */
    PEDIDO_pedido: "Pedido",
    PEDIDO_instancia: "Instancia",
    PEDIDO_ingresadoPor: "Ingresado por",
    PEDIDO_instancia_sin_confirmar: "Sin Confirmar",
    PEDIDO_instancia_proceso: "En proceso",
    PEDIDO_instancia_historico: "Histórico",
    PEDIDO_instancia_confirmado: "Confirmado",
    PEDIDO_numero: "Número",
    PEDIDO_numero_placeholder: "Ingrese número",
    PEDIDO_periodo_meses_1: "Último mes",
    PEDIDO_periodo_meses_2: "Últimos 2 meses",
    PEDIDO_periodo_meses_3: "Últimos 3 meses",
    PEDIDO_periodo_ultimos_2anios: "Últimos 2 años",

    PEDIDO_inicializando_cabecera: "Inicializando cabecera",
    PEDIDO_numero_pedido: "Pedido Número",
    PEDIDO_plazo_pago: "Plazo de pago",
    PEDIDO_nota_comercial: "Nota comercial",
    PEDIDO_nuevo_pedido: "Nuevo pedido",
    PEDIDO_importe_final: "Importe Final",
    PEDIDO_sin_impuesto_ingresos_brutos:
      "No se incluye el impuesto a los Ingresos Brutos",
    PEDIDO_referencia_base_dolar:
      "(+) Precios en base dólar, al momento de facturar se actualizara con la cotización del día anterior a la fecha de factura del Banco Nación tipo vendedor",
    PEDIDO_subtotal: "Subtotal",
    PEDIDO_iva: "IVA",
    PEDIDO_despachado: "Despachado",
    PEDIDO_bonificacion: "Bonificación",
    PEDIDO_promocion: "Promoción",
    PEDIDO_unidad_medida: "Unidad medida",
    PEDIDO_porcentaje_descuento: "P. Descuento",
    PEDIDO_intereses: "Intereses",
    PEDIDO_neto: "Neto",
    PEDIDO_iva_reducido: "IVA Red",
    PEDIDO_periodo: "Periodo",
    PEDIDO_rango: "Rango",
    PEDIDO_producto_missing: "Ingrese un producto",
    PEDIDO_plazo_pago_missing: "Ingrese un plazo de pago",
    PEDIDO_success: "Operación exitosa",
    PEDIDO_importe: "Importes expresados en",
    PEDIDO_detalles: "Detalles del Pedido",
    PEDIDO_cantidad_item: "Cantidad de Items",
    PEDIDO_filtroFaltanDespachar: "Faltan despachar",
    PEDIDO_sin_confirmar: "Cantidad de pedidos sin confirmar",
    PEDIDO_eliminar_mensaje: "¿Desea eliminar el pedido?",
    PEDIDO_eliminar: "Eliminar pedido",
    PEDIDO_descargar_reporte_pdf: "Descargar pdf",
    PEDIDO_descargar_reporte_excel: "Descargar excel",

    PEDIDO_importar_subtitle: "Importar detalles",
    PEDIDO_importar_msg: "Importar detalles desde un archivo EXCEL",
    PEDIDO_importar_seleccione_btn: "Seleccione",
    PEDIDO_importar_importarBtn: "IMPORTAR",
    PEDIDO_importar_procesandoMsg: "Procesando archivo",
    PEDIDO_importar_filasProcesadas: "FILAS PROCESADAS",
    PEDIDO_importar_filasExitosas: "FILAS EXITOSAS",
    PEDIDO_importar_filasConError: "FILAS CON ERROR",
    PEDIDO_importar_nuevaImportacionBtn: "NUEVA IMPORTACIÓN",
    PEDIDO_importar_ejemplo_archivo: "Ver ejemplo archivo",
    PEDIDO_importar_ejemplo_titulo: "Ejemplo de importación",
    PEDIDO_importar_ejemplo_indicaciones:
      "El archivo debe estar en el formato que muestra la imagen y debe ser del tipo .xlsx o .xls",

    PEDIDO_error_importar_formato_incorrecto:
      "Fila [fila]: Formato incorrecto.",
    PEDIDO_error_importar_cantidad_cero: "Fila [fila]: Cantidad cero.",
    PEDIDO_error_importar_error_insercion: "Error en inserción de datos.",
    PEDIDO_error_importar_cantidad_celdas:
      "Fila [fila]: Cantidad incorrecta de celdas.",
    PEDIDO_error_importar_no_admite_decimales:
      "Fila [fila]: El producto no admite decimales.",
    PEDIDO_error_importar_producto_inexistente:
      "Fila [fila]: Clave de producto inexistente.",
    PEDIDO_errores_importacion_titulo: "Errores de importación",
    PEDIDO_error_importar: "[codigo]: [mensaje]",

    PEDIDO_confirmar_title: "Confirmar pedido",
    PEDIDO_confirmarPedidoBtn: "Confirmar pedido",
    PEDIDO_editarPedidoBtn: "Editar pedido",
    PEDIDO_confirmando_pedido: "Confirmando pedido",
    PEDIDO_confirmado: "Pedido confirmado",
    PEDIDO_confirmado_success: "El pedido se confirmó exitosamente",
    PEDIDO_volverAIngresoBtn: "Volver a Ingreso",

    /* Productos */
    PRODUCTO_productos: "Productos",
    PRODUCTO_productos_seleccionados: "Productos Seleccionados",
    PRODUCTO_eliminar: "Eliminar Producto",
    DETALLE_eliminar: "Eliminar Detalle",
    PRODUCTO_eliminar_mensaje: "¿Desea eliminar el producto [codigo]?",
    DETALLE_eliminar_mensaje: "¿Desea eliminar el detalle [codigo]?",
    PRODUCTO_agregar_repetido_mensaje:
      "El producto [codigo] ya se encuentra agregado. ¿Desea continuar?",
    PRODUCTO_estado: "[leyenda]",
    PRODUCTO_equipo: "Equipo",
    PRODUCTO_repuesto: "Repuesto",
    PRODUCTO_detalle: "Detalle del Producto",
    PRODUCTO_agregar: "Agregar producto",
    PRODUCTO_precio_unitario: "Precio unitario",
    PRODUCTO_agregar_producto: "Ingrese un producto seleccionando ",
    PRODUCTO_agregar_producto_cantidad_cero: "La cantidad no puede ser cero.",
    PRODUCTO_agregar_producto_error: "No es posible agregar",
    PRODUCTO_nota_tecnica: "Nota Técnica",
    PRODUCTO_cantidad_encontrados: "[cantidad] productos encontrados",
    // filtros de producto busqueda avanzada
    PRODUCTO_sin_tipo: "No se encontraron [tipo]",
    PRODUCTO_tipo_lineas: "líneas",
    PRODUCTO_tipo_propiedades: "propiedades",

    /* Garantias */

    /* Archivos */
    ARCHIVOS_archivos: "Archivos",
    ARCHIVOS_nombre: "Nombre",
    ARCHIVOS_path: "Archivo",
    ARCHIVOS_incluir_archivos_publicos: "Incluir archivos públicos",
    ARCHIVOS_nuevo_archivo: "Nuevo archivo",
    ARCHIVOS_editar_archivo: "Editar Archivo",
    ARCHIVOS_archivo_guardado: "Archivo guardado con éxito",
    ARCHIVOS_tipo: "Tipo",
    ARCHIVOS_archivo: "Archivo",
    ARCHIVOS_carpeta: "Carpeta",
    ARCHIVOS_link: "Enlace",
    ARCHIVOS_abrirLink: "Abrir enlace",
    ARCHIVOS_seleccionTipo: "Seleccione el tipo de archivo",
    ARCHIVOS_ingresoLink: "Ingrese el enlace",
    ARCHIVOS_descripcion: "Descripción",
    ARCHIVOS_ubicacion: "Ubicación",
    ARCHIVOS_publico: "Público",
    ARCHIVOS_datos_archivo: "Datos de archivo",
    ARCHIVOS_permisos_perfiles: "Permisos: perfiles",
    ARCHIVOS_permisos_usuarios: "Permisos: usuarios",
    ARCHIVOS_nombre_missing: "Ingrese el nombre del archivo",
    ARCHIVOS_descripcion_missing: "Ingrese una descripción del archivo",
    ARCHIVOS_fecha_vencimiento_missing:
      "Ingrese una fecha de vencimiento del archivo",
    ARCHIVOS_archivo_missing: "Debe cargar un archivo",
    ARCHIVOS_link_missing: "Debe cargar un enlace",
    ARCHIVOS_ubicacion_missing: "Ingrese la ubicación del archivo",
    ARCHIVO_success: "Archivo guardado con éxito",
    ARCHIVOS_descargar: "Descargar",
    ARCHIVOS_fecha_vencimiento: "Fecha de vencimiento",
    ARCHIVOS_fecha_creacion: "Fecha de creación",
    ARCHIVOS_eliminar: "Eliminar archivo",
    ARCHIVOS_eliminar_carpeta: "Eliminar carpeta",
    ARCHIVOS_eliminar_mensaje: '¿Desea eliminar el archivo "[titulo]"?',
    ARCHIVOS_carpeta_eliminar_mensaje: '¿Desea eliminar la carpeta "[titulo]"?',
    ARCHIVOS_listas_todos: "Todos",
    ARCHIVOS_listas_elegidos: "Elegidos",
    ARCHIVOS_perfiles_filtro_placeholder: "Buscar perfiles",
    ARCHIVOS_usuarios_filtro_placeholder: "Buscar usuarios",
    ARCHIVOS_heredar_permisos: "Heredar permisos",
    ARCHIVOS_es_archivo: "Es archivo",
    ARCHIVOS_carpeta_vacia: "No hay archivos para mostrar",
    ARCHIVOS_error_descarga: "Error: no se pudo descargar el archivo",

    /* Noticias */
    HOME_avisos_importantes: "Notificaciones",
    HOME_avisos_alertas: "Alertas",
    HOME_avisos_advertencias: "Advertencias",
    HOME_avisos_informacion: "Informaci\u00f3n",
    NOTICIAS_empty_state: "No hay noticias para mostrar",
    NOTICIAS_leer_mas: "LEER MÁS",
    NOTICIAS_nueva_noticia: "Noticia",
    NOTICIAS_noticias: "Noticias",
    NOTICIAS_titulo: "Título",
    NOTICIAS_copete: "Copete",
    NOTICIAS_cuerpo: "Cuerpo",
    NOTICIAS_imagen_principal: "Imagen principal",
    NOTICIAS_titulo_missing: "Ingrese el título",
    NOTICIAS_copete_missing: "Ingrese el copete",
    NOTICIAS_cuerpo_missing: "Ingrese el cuerpo",
    NOTICIAS_success: "Operación exitosa",
    NOTICIAS_error: "Se produjo un error al intentar guardar la noticia",
    NOTICIAS_registrado_por: "Registrada por",
    NOTICIAS_estado: "Estado",
    NOTICIAS_fecha_registro: "Fecha de registro",
    NOTICIAS_fecha_publicacion: "Fecha de publicacion",
    NOTICIAS_seleccionar_estado: "Seleccione",
    NOTICIAS_estado_borrador: "Borrador",
    NOTICIAS_estado_publicado: "Publicada",
    NOTICIAS_estado_eliminado: "Eliminada",
    NOTICIAS_publicar: "Publicar",
    NOTICIA_publicar_mensaje: "¿Desea publicar la noticia [titulo]?",
    NOTICIA_publicar: "Publicar noticia",
    NOTICIA_eliminar_mensaje: "¿Desea eliminar la noticia [titulo]?",
    NOTICIA_eliminar: "Eliminar noticia",

    /* Garantias */
    GARANTIAS_filtros: "Filtros",
    GARANTIAS_ns: "Nro. Serie Elemento / Lote / Código",
    GARANTIAS_numero_serie: "Número de serie",
    GARANTIAS_ns_a_registrar: "NS a Registrar",
    GARANTIAS_canje: "Solicitar canje",
    GARANTIAS_ti_canje: "Canje",
    GARANTIAS_asociar_elementos:
      "¿Desea asociar este elemento con otro Número de Serie?",
    GARANTIAS_fecha_instalacion: "Fecha de instalación",
    GARANTIAS_ns_asoc: "NS del Elemento Asociado",
    GARANTIAS_noEsCanjeable: "No es Canjeable",
    GARANTIAS_patente: "Patente",
    GARANTIAS_tiene_patente: "¿Tiene patente?",
    GARANTIAS_nro_patente: "Número de patente",
    GARANTIAS_marca_modelo: "Marca y Modelo",
    GARANTIAS_marca_modelo_unidad: "Marca y Modelo de la unidad",
    GARANTIAS_datos_usuario: "Datos del usuario/empresa",
    GARANTIAS_usuario: "Usuario",
    GARANTIAS_razon_nombre: "Razón Social / Nombre y apellido",
    GARANTIAS_incl_prod_asoc: "Incluir Prod. Asociados",
    GARANTIAS_en_garantia: "En Garantía",
    GARANTIAS_sin_garantia: "Sin Garantía",
    GARANTIAS_telefono: "Teléfono",
    GARANTIAS_instalado: "Instalado",
    GARANTIAS_vence: "Garantía Vence",
    GARANTIAS_cod_prod: "Cód. Producto",
    GARANTIAS_garantia: "Garantía",
    GARANTIAS_garantia_adic: "Garantía Adic.",
    GARANTIAS_registrado_por: "Registrado por",
    GARANTIAS_servicio_oficial: "S. Oficial",
    GARANTIAS_producto_descripcion: "Descripción",
    GARANTIAS_meses: "meses",
    GARANTIAS_registro_instalacion: "Registro de instalación",
    GARANTIAS_registro_exito: "Instalación Registrada con Éxito",
    GARANTIAS_datos_equipo: "Datos del equipo/elemento",
    GARANTIAS_venc_garantia_periodo: "Período",
    GARANTIAS_venc_garantia_rango: "Rango",
    GARANTIAS_venc_garantia_meses_1: "Vencen en 1 mes",
    GARANTIAS_venc_garantia_meses_3: "Vencen en 3 meses",
    GARANTIAS_venc_garantia_meses_menos_1: "Vencidas hace 1 mes",
    GARANTIAS_venc_garantia_meses_menos_12: "Vencidas hace 1 año",

    /* Solicitudes de Servicio */
    SOLICITUD_btn_editar: "Editar",
    SOLICITUD_btn_borrar: "Eliminar",
    SOLICITUD_btn_anular: "Anular",
    SOLICITUD_btn_desasociar: "Desasociar",
    SOLICITUDES_solicitud: "Solicitud Número [nro_solicitud]",
    SOLICITUDES_solicitud_servicio: "Solicitud de Servicio",
    SOLICITUDES_solicitud_servicio_guardada: "Solicitud guardada con éxito",
    SOLICITUDES_nro_solicitud: "Número de Solicitud",
    SOLICITUDES_ns: "Número de serie",
    SOLICITUDES_clave: "Código",
    SOLICITUDES_nro_remito: "Número de remito",
    SOLICITUDES_instancia: "Instancia",
    SOLICITUDES_tipo_servicio: "Tipo",
    SOLICITUDES_check_garantia: "Garantía",
    SOLICITUDES_check_reparacion: "Reparación",
    SOLICITUDES_check_canje: "Canje",
    SOLICITUDES_label_observaciones: "Aclaración de falla / Observaciones",
    SOLICITUDES_placeholder_observaciones: "Descripción...",
    SOLICITUDES_motivo: "Motivo",
    SOLICITUDES_descripcion_vacia: "No posee descripcion disponible",
    SOLICITUDES_ultimo_mes: "Último Mes",
    SOLICITUDES_ultimos_3_meses: "Últimos 3 Meses",
    SOLICITUDES_ultimo_anio: "Último Año",
    SOLICITUDES_confirmado_periodo: "Período",
    SOLICITUDES_confirmado_rango: "Rango",
    SOLICITUDES_borrar_solicitud_titulo: "Eliminar solicitud",
    SOLICITUDES_observaciones1: "Descripción de Imagen 1",
    SOLICITUDES_observaciones2: "Descripción de Imagen 2",
    SOLICITUDES_observaciones3: "Descripción de Imagen 3",

    SOLICITUDES_nro_serie_missing: "Ingrese un número de serie válido",
    SOLICITUDES_nro_serie_asociado_missing:
      "Ingrese un NS del elemento asociado válido",
    SOLICITUDES_observaciones_missing: "Ingrese la descripción de la falla",
    SOLICITUDES_patente_missing: "Ingrese la patente",
    SOLICITUDES_marca_modelo_missing: "Ingrese la marca y modelo",
    SOLICITUDES_motivo_missing: "Seleccione el motivo del canje",
    SOLICITUDES_alta_error:
      "Error al intentar guardar la solicitud de servicio (error: [errorCode])",
    SOLICITUDES_alta_success:
      "Operación exitosa. Número de solicitud generada: [nro_solicitud]",
    SOLICITUDES_edicion_success:
      "La solicitud de servicio se modificó correctamente",
    SOLICITUDES_borrar_solicitud_mensaje:
      "¿Desea eliminar la solicitud número [nro_solicitud]?",

    /* Asociación a remitos */
    SOLICITUD_REMITO_btn_asociar_remito: "Asociar a remito",
    SOLICITUD_REMITO_asociar_remito: "Asociar a remito",
    SOLICITUD_REMITO_nro_remito_input: "Ingrese el número de remito",
    SOLICITUD_REMITO_nro_remito: "Número de remito",

    SOLICITUD_REMITO_nro_sol: "Solicitud de Servicio",
    SOLICITUD_REMITO_ns: "NS",
    SOLICITUD_REMITO_clave: "Código",
    SOLICITUD_REMITO_descripcion: "Descripción",
    SOLICITUD_REMITO_servicio_oficial: "S. Oficial",
    SOLICITUD_REMITO_instancia: "Instancia",
    SOLICITUD_REMITO_tipo_servicio: "Tipo",
    SOLICITUD_REMITO_anular_solicitud: "Anular solicitud",

    SOLICITUD_REMITO_solicitud_no_seleccionado:
      "Debe seleccionar al menos una solicitud",
    SOLICITUD_REMITO_confirmacion_titlo: "Confirmar asociación",
    SOLICITUD_REMITO_confirmacion_mensaje:
      "¿Asociar las solicitudes al número de remito [nro_remito]?",
    SOLICITUD_REMITO_exito:
      "Solicitudes asociadas al número de remito [nro_remito]",

    SOLICITUD_REMITO_anular_solicitud_titulo: "Anular Solicitud de Servicios",
    SOLICITUD_REMITO_anular_solicitud_mensaje:
      "¿Desea Anular la Solicitud de Servicios [nro_solicitud]?",

    SOLICITUD_REMITO_desasociar_remito_titulo: "Desasociar remito",
    SOLICITUD_REMITO_desasociar_remito_mensaje:
      "¿Desea desasociar la solicitud [nro_solicitud] con el remito [nro_remito]?",

    /* Firmar Remitos */
    NAVBAR_firmarRemitos: "Firmar Remitos",
    FIRMAR_REMITOS_titulo: "Firmar Remitos",
    FIRMAR_REMITOS_filtro_id: "Número Remito",
    FIRMAR_REMITOS_filtro_id_placeholder: "Buscar por número...",
    FIRMAR_REMITOS_filtro_estado: "Estado",
    FIRMAR_REMITOS_filtro_firmados: "Firmados",
    FIRMAR_REMITOS_filtro_no_firmados: "No Firmados",
    FIRMAR_REMITOS_sin_firmar: "Sin Firmar",
    FIRMAR_REMITOS_firmados: "Firmados",
    FIRMAR_REMITOS_tabla_fecha: "Fecha",
    FIRMAR_REMITOS_tabla_tipo: "Tipo",
    FIRMAR_REMITOS_tabla_documento: "Documento",
    FIRMAR_REMITOS_tabla_remito: "Remito",
    FIRMAR_REMITOS_tabla_nro: "Nro.",
    FIRMAR_REMITOS_tabla_cant_items: "Cant. Items",
    FIRMAR_REMITOS_tabla_por: "Firmado por",
    FIRMAR_REMITOS_tabla_el: "Firmado el",
    FIRMAR_REMITOS_tabla_firma_notas: "Nota",
    FIRMAR_REMITOS_tabla_conforme: "Conforme",
    FIRMAR_REMITOS_ver_remito: "Ver Remito",
    FIRMAR_REMITOS_tabla_acciones: "Acciones",
    FIRMAR_REMITOS_descargar_pdf: "Descargar PDF",
    FIRMAR_REMITOS_firmar: "Firmar remito",
    FIRMAR_REMITOS_modal_titulo: "Firmar Remito",
    FIRMAR_REMITOS_modal_confirmacion: "Confirma recepción total de la mercadería del remito.",
    FIRMAR_REMITOS_modal_notas: "Nota",
    FIRMAR_REMITOS_modal_notas_placeholder: "Ingrese nota...",
    FIRMAR_REMITOS_modal_confirmar: "Firmar",
    FIRMAR_REMITOS_modal_confirmar_conforme: "Firmo Conforme",
    FIRMAR_REMITOS_modal_confirmar_no_conforme: "Firmo No Conforme",
    FIRMAR_REMITOS_nota_requerida_no_conforme: "Se debe adjuntar una Nota para firmar no conforme.",
    FIRMAR_REMITOS_pdf_descargado: "PDF descargado correctamente",
    FIRMAR_REMITOS_error_descargar: "Error al descargar el PDF",
    FIRMAR_REMITOS_firmado_exito: "Remito firmado correctamente",
    FIRMAR_REMITOS_error_firmar: "Error al firmar el remito",
    FIRMAR_REMITOS_error_cargar: "Error al cargar los remitos",

    /* Foro */
    FORO_nuevo_post: "Nuevo post",
    FORO_titulo: "Título",
    FORO_descripcion: "Descripción",
    FORO_imagenes: "Imágenes",
    FORO_titulo_missing: "Ingrese el título",
    FORO_descripcion_missing: "Ingrese la descripción",
    FORO_exito: "El post se generó correctamente",
    FORO_error: "Error al generar el post",
    FORO_missing: "No se encontró la entrada de foro",
    FORO_archivar: "Archivar",
    FORO_confirmado: "Confirmado",
    FORO_archivado: "Archivado",
    FORO_responder: "Responder",
    FORO_comentar: "Comentar",
    FORO_comentario_placeholder: "Comentario...",
    FORO_permitir_imagenes: "Permitir la carga de imagenes",
    FORO_foros: "Foros",
    FORO_imagen_grande: "La imagen cargada es muy grande",

    /* Foro comentario */
    FORO_comentario_missing: "Ingrese un comentario",
    FORO_comentario_exito: "Comentario generado correctamente",
    FORO_comentario_error: "Error al generar el comentario",

    /* Instancias */
    INSTANCIA_PENDIENTE_ASOCIAR: " Pendiente de asociar con remito",
    INSTANCIA_PENDIENTE_ENVIAR: " Pendiente de enviar a Colven",
    INSTANCIA_ENVIADO: " Enviado a Colven",
    INSTANCIA_PROCESO: " En Proceso",
    INSTANCIA_HISTORICO: " En Histórico",

    /* File upload */
    FILE_UPLOAD_cargar_imagen: "Cargar imagen",
    FILE_UPLOAD_cargar_archivo: "Cargar archivo",
    FILE_UPLOAD_limite_exedido: "Se superó la cantidad de archivos permitidos",
    FILE_UPLOAD_extension_no_permitida:
      "La extensión del archivo no está permitida",

    /* Presupuestos */
    PRESUPUESTO_pedido: "Presupuesto",
    PRESUPUESTO_instancia: "Instancia",
    PRESUPUESTO_ingresadoPor: "Ingresado por",
    PRESUPUESTO_instancia_ingresado: "Ingresado",
    PRESUPUESTO_instancia_proceso: "En proceso",
    PRESUPUESTO_instancia_historico: "Histórico",
    PRESUPUESTO_instancia_confirmado: "Confirmado",
    PRESUPUESTO_numero: "Número",
    PRESUPUESTO_numero_placeholder: "Ingrese número",
    PRESUPUESTO_periodo_meses_1: "Último mes",
    PRESUPUESTO_periodo_meses_2: "Últimos 2 meses",
    PRESUPUESTO_periodo_meses_3: "Últimos 3 meses",
    PRESUPUESTO_periodo_ultimos_2anios: "Últimos 2 años",
    PRESUPUESTO_eliminar_mensaje: "¿Desea eliminar el presupuesto?",
    PRESUPUESTO_eliminar: "Eliminar presupuesto",
    PRESUPUESTO_inicializando_cabecera: "Inicializando cabecera",
    PRESUPUESTO_numero_presupuesto: "Presupuesto Número",
    PRESUPUESTO_plazo_pago: "Plazo de pago",
    PRESUPUESTO_nota_comercial: "Nota comercial",
    PRESUPUESTO_nuevo_presupuesto: "Nuevo presupuesto",
    PRESUPUESTO_importe_final: "Importe Final",
    PRESUPUESTO_sin_impuesto_ingresos_brutos:
      "No se incluye el impuesto a los Ingresos Brutos",
    PRESUPUESTO_referencia_base_dolar:
      "(+) Precios en base dólar, al momento de facturar se actualizará con la cotización del día anterior a la fecha de factura del Banco Nación tipo vendedor",
    PRESUPUESTO_subtotal: "Subtotal",
    PRESUPUESTO_iva: "IVA",
    PRESUPUESTO_despachado: "Despachado",
    PRESUPUESTO_bonificacion: "Bonificación",
    PRESUPUESTO_unidad_medida: "Unidad medida",
    PRESUPUESTO_porcentaje_descuento: "P. Descuento",
    PRESUPUESTO_intereses: "Intereses",
    PRESUPUESTO_neto: "Neto",
    PRESUPUESTO_iva_reducido: "IVA Red",
    PRESUPUESTO_periodo: "Periodo",
    PRESUPUESTO_rango: "Rango",
    PRESUPUESTO_producto_missing: "Ingrese un producto o un detalle",
    PRESUPUESTO_plazo_pago_missing: "Ingrese un plazo de pago",
    PRESUPUESTO_razon_social_missing: "Ingrese la Razón Social",
    PRESUPUESTO_domicilio_missing: "Ingrese el Domicilio",
    PRESUPUESTO_fecha_vigencia_missing: "Ingrese una Fecha de vigencia",
    PRESUPUESTO_fecha_vigencia_incorrect: "Fecha de Vigencia Incorrecta",
    PRESUPUESTO_success: "Operación exitosa",
    PRESUPUESTO_importe: "Importes expresados en",
    PRESUPUESTO_detalles: "Detalles del Presupuesto",
    PRESUPUESTO_domicilio: "Domicilio",
    PRESUPUESTO_vigencia: "Fecha Vigencia",
    PRESUPUESTO_razon_social: "Razón Social",
    PRESUPUESTO_razon_social_placeholder: "Ingrese Razón Social",
    PRESUPUESTO_domicilio_placeholder: "Ingrese Domicilio",
    PRESUPUESTO_mano_obra: 'Mano de Obra:',
    PRESUPUESTO_mo: 'M.O.:',

    PRESUPUESTO_importar_subtitle: "Importar detalles",
    PRESUPUESTO_importar_msg: "Importar detalles desde un archivo EXCEL",
    PRESUPUESTO_importar_seleccione_btn: "Seleccione",
    PRESUPUESTO_importar_importarBtn: "IMPORTAR",
    PRESUPUESTO_importar_procesandoMsg: "Procesando archivo",
    PRESUPUESTO_importar_filasProcesadas: "FILAS PROCESADAS",
    PRESUPUESTO_importar_filasExitosas: "FILAS EXITOSAS",
    PRESUPUESTO_importar_filasConError: "FILAS CON ERROR",
    PRESUPUESTO_importar_nuevaImportacionBtn: "NUEVA IMPORTACIÓN",
    PRESUPUESTO_importar_ejemplo_archivo: "Ver ejemplo archivo",
    PRESUPUESTO_importar_ejemplo_titulo: "Ejemplo de importación",
    PRESUPUESTO_importar_ejemplo_indicaciones:
      "El archivo debe estar en el formato que muestra la imagen y debe ser del tipo .xlsx o .xls",

    PRESUPUESTO_error_importar_formato_incorrecto:
      "Fila [fila]: Formato incorrecto.",
    PRESUPUESTO_error_importar_cantidad_cero: "Fila [fila]: Cantidad cero.",
    PRESUPUESTO_error_importar_error_insercion: "Error en inserción de datos.",
    PRESUPUESTO_error_importar_cantidad_celdas:
      "Fila [fila]: Cantidad incorrecta de celdas.",
    PRESUPUESTO_error_importar_no_admite_decimales:
      "Fila [fila]: El producto no admite decimales.",
    PRESUPUESTO_error_importar_producto_inexistente:
      "Fila [fila]: Clave de producto inexistente.",
    PRESUPUESTO_errores_importacion_titulo: "Errores de importación",
    PRESUPUESTO_error_importar: "[codigo]: [mensaje]",

    PRESUPUESTO_confirmar_title: "Confirmar presupuesto",
    PRESUPUESTO_confirmarPresupuestoBtn: "Confirmar presupuesto",
    PRESUPUESTO_editarPresupuestoBtn: "Editar presupuesto",
    PRESUPUESTO_confirmando_presupuesto: "Confirmando presupuesto",
    PRESUPUESTO_confirmado: "Presupuesto confirmado",
    PRESUPUESTO_confirmado_success: "El presupuesto se confirmó exitosamente",
    PRESUPUESTO_volverAIngresoBtn: "Volver a Ingreso",

    PRESUPUESTO_agregar_detalle: "Agregar detalle",
    PRESUPUESTO_productos_detalles_seleccionados:
      "Productos y detalles seleccionados",
    PRESUPUESTO_agregar_producto_detalle:
      "Ingrese un producto o un detalle seleccionando ",
    PRESUPUESTO_detalle: "Detalle",
    PRESUPUESTO_detalle_descripcion_placeholder:
      "Ingrese una descripción para el detalle",
    PRESUPUESTO_detalle_precio_placeholder: "Precio unitario",
    PRESUPUESTO_detalle_IVA_label: "Tipo de IVA",
    PRESUPUESTO_detalle_IVA_21: "IVA gravado 21%",
    PRESUPUESTO_detalle_IVA_10: "IVA reducido 10,5%",
    PRESUPUESTO_detalle_IVA_0: "Exento de IVA",
    PRESUPUESTO_detalle_label_cantidad: "Cantidad",
    PRESUPUESTO_detalle_nota_tecnica: "Nota técnica",
    PRESUPUESTO_detalle_nota_tecnica_placeholder: "Ingrese una nota técnica",
    PRESUPUESTO_descripcion_editar_placeholder: "Descripción",
    PRESUPUESTO_precio_editar_placeholder: "Precio",
    PRESUPUESTO_descargar_reporte: "Descargar",

    PRESUPUESTO_descripcion_error: "Ingrese la descripción del detalle",
    PRESUPUESTO_precio_unitario_error: "Ingrese el precio unitario",
    PRESUPUESTO_cantidad_error: "Ingrese una cantidad no nula",

    /* Pedidos a Distribuidores */
    PEDIDOADISTRIBUIDORES_pedido: "Pedido a Distribuidores",
    PEDIDOADISTRIBUIDORES_instancia_ingreso: "Ingreso",
    PEDIDOADISTRIBUIDORES_instancia_confirmado: "Confirmado",
    PEDIDOADISTRIBUIDORES_instancia_seleccionado: "Seleccionado",
    PEDIDOADISTRIBUIDORES_instancia_historico: "Historico",
    PEDIDOADISTRIBUIDORES_nuevo_pedido: "Nuevo Pedido a Distribuidor",
    PEDIDOADISTRIBUIDORES_confirmar_pedido: "Confirmar Pedido a Distribuidor",

    /* Pedidos Subagentes */
    PEDIDOSUBAGENTE_pedido: "Pedidos Subagentes",
    PEDIDOSUBAGENTE_instancia_confirmado: "Confirmado",
    PEDIDOSUBAGENTE_instancia_historico: "Historico",
    PEDIDOSUBAGENTE_instancia_seleccionado: "Seleccionado",
    PEDIDOSUBAGENTE_nuevo_pedido: "Nuevo Pedido Subagente",
    PEDIDOSUBAGENTE_confirmar_pedido: "Confirmar Pedido Subagente",
    PEDIDOSUBAGENTE_instancia_ingreso: "Ingreso",
    PEDIDOSUBAGENTE_pasar_a_seleccionados: "Pasar a Seleccionados",
    PEDIDOSUBAGENTE_pasar_a_historicos: "Pasar a Historicos",
    PEDIDOSUBAGENTE_pasar_a_seleccionados_msg: "Desea pasar los pedidos a la instancia 'Seleccionados para Procesar'?",
    PEDIDOSUBAGENTE_pasar_a_historicos_msg: "Desea pasar los pedidos a la instancia 'Historicos'?",
    PEDIDOSUBAGENTE_seleccione_pedido: "Debe seleccionar al menos un Pedido",
    PEDIDOSUBAGENTE_seleccione_todos: "Seleccionar todos",
    PEDIDOSUBAGENTE_exportar: "Exportar",
    PEDIDOSUBAGENTE_exportar_excel_consolidado: "Exportar Excel Consolidado",
    PEDIDOSUBAGENTE_exportar_excel_detalles: "Exportar Excel de Detalles",
    PEDIDOSUBAGENTE_pedido_consolidados: "Pedidos Subagentes Consolidados",
    PEDIDOSUBAGENTE_pedido_detalles: "Pedidos Subagentes Detalles",
    PEDIDOSUBAGENTE_cliente: "Cliente",

    /*Pendientes*/
    PENDIENTES_cuenta_corrientes: "Cuenta Corriente",
    PENDIENTES_agrupar_por: "Agrupar Datos por:",
    PENDIENTES_cc_placeholer: "Seleccione una Cuenta Corriente",
    PENDIENTES_semana: "Semana",
    PENDIENTES_mes: "Mes",
    PENDIENTES_sin_agrupar: "Sin Agrupar",
    PENDIENTES_vencimiento: "Vencimiento",
    PENDIENTES_vence_el: "Vence el",
    PENDIENTES_tipo: "Tipo",
    PENDIENTES_serie: "Serie",
    PENDIENTES_suc: "Suc.",
    PENDIENTES_punto_venta: "Pto Venta",
    PENDIENTES_numero: "Número",
    PENDIENTES_plazo_pago: "Plazo Pago",
    PENDIENTES_fecha_documento: "F. Documento",
    PENDIENTES_debe_pendiente: "Debe Pendiente",
    PENDIENTES_haber_pendiente: "Haber Pendiente",
    PENDIENTES_cuotas: "Cuota",
    PENDIENTES_debe: "Debe",
    PENDIENTES_haber: "Haber",
    PENDIENTES_desde: "Desde",
    PENDIENTES_hasta: "Hasta",
    PENDIENTES_descargar_excel: "Exportar a Excel",
    PENDIENTES_estado_vencimiento: "Estado Vencimiento",
    PENDIENTES_todos: "Todos",
    PENDIENTES_a_vencer: "A Vencer",
    PENDIENTES_vencido: "Vencido",
    GETCUENTASCORRIENTES_error: "Hubo un error al obtener las cuentas corrientes",
    PENDIENTES_exportar: "Exportar",
    PENDIENTES_total_debe: "Total debe",
    PENDIENTES_total_haber: "Total haber",
    PENDIENTES_buscar: "Seleccione Cuenta Corriente y Agrupamiento para comenzar la búsqueda",
    PENDIENTES_datos_agrupados_por: "Datos agrupados por",
    PENDIENTES_error_exportar1: "Seleccione Cuenta Corriente y Agrupamiento para descargar el excel",


    /*Mensaje para mostrar en la tabla cuando no hay datos*/
    EL_TABLE_sin_datos: "Sin datos",




    /* Errores de autorización */
    ERROR_CODE_AUTH_0: "Operación Exitosa", // OK
    ERROR_CODE_AUTH_1: "Aplición Inválida", // AplicacionInvalida
    ERROR_CODE_AUTH_2: "Usuario y/o contraseña invalidos", // UsuarioContraseniaInvalidos
    ERROR_CODE_AUTH_3: "Servidor LDAP sin conexión", // ServidorLDAPSinConexion
    ERROR_CODE_AUTH_4: "Usuario excede cantidd de instancis instaladas", // UsuarioExcedeCantidadInstanciasInstaladas
    ERROR_CODE_AUTH_5: "Usuario sin empresa", // UsuarioSinEmpresa
    ERROR_CODE_AUTH_6: "Empresa sin país", // EmpresaSinPais
    ERROR_CODE_AUTH_7: "Servidor LDAP Error General", // ServidorLDAPErrorGeneral
    ERROR_CODE_AUTH_8: "Error al actualizar usuario", // UsuarioErrorAlActualizar
    ERROR_CODE_AUTH_9: "Error de parámetros", // ErrorDeParametros
    ERROR_CODE_AUTH_10: "No se permite cambiar contraseña", // UsuarioADNoSePermiteCambiarContrasenia
    ERROR_CODE_AUTH_11:
      "Token expirado o inválido, por favor restablecer nuevamente la contraseña", // TokenInvalido
    ERROR_CODE_AUTH_12: "Longitud contraseña inválida", // LongitudContraseniaInvalido
    ERROR_CODE_AUTH_13: "Error al enviar mail", // EnviarMailError
    ERROR_CODE_AUTH_14: "Usuario sin email", // UsuarioSinEmail
    ERROR_CODE_AUTH_17: "No es posible el blanqueo de contraseña para el usuario", // Usuario AD no permite recuperar contrasenia

    /* Error Codes GARANTÍAS*/
    "ERROR_CODE_-1": "Se produjo un error inesperado",
    "ERROR_CODE_-2": "Aplicación inválida",
    "ERROR_CODE_-3": "Usuario y/o contraseña inválidos",
    "ERROR_CODE_-4": "No hay conexión con el servidor LDAP",
    "ERROR_CODE_-5":
      "Se excedió la cantidad permitida de instancias de aplicación instaladas",
    "ERROR_CODE_-6": "El usuario no tiene una empresa asignada",
    "ERROR_CODE_-7": "La empresa no tiene un país asignado",
    "ERROR_CODE_-8": "Se produjo un error al interactuar con el servidor LDAP",
    "ERROR_CODE_-9": "Error al actualizar el usuario",
    "ERROR_CODE_-10": "Error de parámetros",
    "ERROR_CODE_-11": "No se permite modificar la contraseña del usuario AD",
    "ERROR_CODE_-12": "Error al copiar los archivos",

    /* Error Codes PEDIDOS */
    "ERROR_CODE_-100": "Ingrese el código de perfil",
    "ERROR_CODE_-101": "Ingrese la descripción del perfil",
    "ERROR_CODE_-102": "Ingrese el mensaje a enviar",
    "ERROR_CODE_-103": "Error al recuperar la foto del negocio",
    "ERROR_CODE_-104": "Error al enviar el email",

    /* Error Codes NOTICIAS */
    "ERROR_CODE_-105": "Error al guardar la noticia",
    "ERROR_CODE_-106": "La noticia no existe en la base de datos",
    "ERROR_CODE_-107": "Seleccione el estado de la noticia",
    "ERROR_CODE_-108": "Ingrese el título de la noticia",
    "ERROR_CODE_-109": "Ingrese el copete de la noticia",
    "ERROR_CODE_-110": "Ingrese el cuerpo de la noticia",

    /* Error Codes FORO */
    "ERROR_CODE_-111": "Error al guardar la entrada de foro",
    "ERROR_CODE_-112": "La entrada de foro no existe en la base de datos",
    "ERROR_CODE_-113": "Ingrese el título de la entrada de foro",
    "ERROR_CODE_-114": "Ingrese la descripción de la entrada de foro",

    "ERROR_CODE_-115": "Error al guardar el comentario de foro",
    "ERROR_CODE_-116": "El comentario de foro no existe en la base de datos",
    "ERROR_CODE_-117": "Error al recuperar el padre del comentario de foro",
    "ERROR_CODE_-118": "Ingrese el comentario de foro",
    "ERROR_CODE_-135": "Este foro no permite cargar imágenes",

    "ERROR_CODE_-119": "Seleccione el área a la cual enviar el email",
    "ERROR_CODE_-120": "Ingrese el mensaje a enviar",
    "ERROR_CODE_-121": "Error al enviar el email",

    /* Error Codes ARCHIVOS */
    "ERROR_CODE_-124": "El archivo no existe en la base de datos",
    "ERROR_CODE_-125": "Debe cargar un archivo",
    "ERROR_CODE_-126": "Ingrese el nombre del archivo",
    "ERROR_CODE_-127": "Ingrese una descripción del archivo",
    "ERROR_CODE_-128": "Error al guardar archivo",
    "ERROR_CODE_-136": "Error al crear la carpeta",
    "ERROR_CODE_-137":
      "Error al eliminar la carpeta. Verifique que no contenga archivos",

    /* Error Codes Pedido */
    "ERROR_CODE_-122": "El pedido no existe en la base de datos",
    "ERROR_CODE_-123": "El pedido está duplicado en la base de datos",
    "ERROR_CODE_-129": "No se pudo recuperar el archivo importado",

    /* Errores Resumen de cuenta */
    "ERROR_CODE_-139": 'El recibo se encuentra duplicado',
    "ERROR_CODE_-140": 'La factura se encuentra duplicada',
    "ERROR_CODE_-141": 'La factura no existe',
    /* Errores Generales */
    ERROR_CODE_NETWORK: "Error en la red",
    ERROR_CODE_UNAUTHORIZED:
      "No tiene permisos para realizar la operación solicitada",
    ERROR_CODE_999: "No implementado",
    ERROR_CODE_9998: "No implementado",
    ERROR_CODE_9999: "Error no contemplado",

    "ERROR_CODE_-131": "La extensión del archivo no está permitida"
  }
};

const i18n = createI18n({
  legacy: true,
  locale: "es",
  fallbackLocale: "es",
  messages: messages
});

Object.defineProperties(i18n, {
  locale: {
    get() {
      const locale = i18n.global.locale;
      return typeof locale === "string" ? locale : locale.value;
    },
    set(value) {
      if (typeof i18n.global.locale === "string") {
        i18n.global.locale = value;
        return;
      }

      i18n.global.locale.value = value;
    }
  },
  messages: {
    get() {
      return messages;
    }
  }
});

export default i18n;
